import { Injectable } from '@angular/core';
import { UserTypeList } from 'app/dashboard/Models/usertypelist.model';
import { HttpClient } from '@angular/common/http';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { BehaviorSubject, forkJoin, Observable } from 'rxjs'
import { MatDialog } from '@angular/material/dialog';
import { PatientDetailModel } from '../Models/patient_details.model';
import { AppointmentsModel } from 'app/opdvisits/Models/appointment.model';
import { opdvisit_returnModel } from '../Models/opdvist_return.model';
import { AuthService } from 'app/auth/auth.service';
import { Router } from '@angular/router';
import { CountryModel } from 'app/table-list/Models/country.model';
import { statemodel } from 'app/table-list/Models/state.model';
import { DistrictModel } from 'app/table-list/Models/district.model';
import { CityModel } from 'app/table-list/Models/city.model';
import { InitialsModel } from 'app/table-list/Models/initials.model';
import { AreaModel } from 'app/table-list/Models/area.model';
import { OtherInfoddModel } from 'app/table-list/Models/otherinfor_dd.model';
import { PersonMasterModel } from 'app/table-list/Models/personmaster.model';
import { PartyMasterModel } from 'app/table-list/Models/partymaster.model';
import { DatePipe } from '@angular/common';
import { examinationModel } from '../Models/examination_details.model';
import { BillsummaryModel } from '../Models/billsummary.model';
import { surgeory_advised_Model } from '../Models/surgeory_advised.model';
import { surgeory_done_Model } from '../Models/surgeory_done.model';
import { Dist_State_CountryID_Model } from '../Models/dist_state_countryid.model';
import { DashboardModel } from 'app/dashboard/Models/dashboard.model';
import { SiteloaderComponent } from 'app/auth/siteloader/siteloader.component';
import { VisitDateModel } from 'app/table-list/Models/visitdate.model';
import { OpdAppointmentsModel } from '../Models/opdappointment.model';
import { ApptSearchModel } from '../Models/ApptSearchModel.model';
import { AppointmentService } from 'app/upgrade/appointment.service';
import { blockTimeModel } from '../blockTimeModel.model';
import { cancelModel } from '../cancelModel.model';
import { SmsSendModel, SmsSendWhatAppModel } from '../Models/SendSMS.model';
import { BillingserviceService } from 'app/billing/billingService.service';
import { PatientEMRModel } from 'app/EMR/HistoryModels/patientExaminationdata.model';
import { DocFileModel } from 'app/table-list/Models/Docfile.model';
import { WebSocketService } from 'app/EMR/webSocket.Service';


@Injectable({
  providedIn: 'root'
})
export class OpdVisitService {
  public agehide: boolean;
  reffertypeid;
  activevisit = 0;
  //for emr header
  partymaster_name: string;
  bloodgroup_name: string;
  refferedby_name: string;
  referrebyid: number;
  // flag_from_opdvisit = false;
  dataSource: DocFileModel[] = [];
  flag: string;
  flag_reg_from_appointments = false;
  WinsCount: number = 0;
  RefreshCount: number = 0;
  config_cityid;
  registereddate
  registeredtime
  stateid: number = 0;
  localstateid: number = 0;
  localcountryid: number = 0;
  countryid: number = 0;
  districtid: number = 0;
  localdistrictid: number = 0;
  bookingDate = new Date();
  public appServiceLocal: number = 0;
  public blockApptTime: string;
  public appId: number;
  public DoctorId: number;
  public DoctorIdEmr: any;
  public printpriciptionAge: any;
  public currDate = new Date();
  public checkpatient: number;
  public BillingDoctorId: any;
  public patiendFullNameForReciept: any;
  public ShowOccupationName: any;
  public ShowGroupName: any;
  public visitid: number;
  public patientDrdetaill: PatientEMRModel[] = [];
  public callsepecificApi: any = "ALL"
  public getlastvisitid: any = 0;
  // this will be used on opdvisit component to check if opd visit already exists for the same day
  opdvisits: DashboardModel[] = [];
  //************************************************* */

  visitdates: VisitDateModel[] = [];

  opdvisitmodel: opdvisit_returnModel = {};
  patientdetails: PatientDetailModel = {};
  apptdetail: OpdAppointmentsModel = {};
  oldPatDetails: any;
  blockTimeDetail: blockTimeModel = {};
  apptsearchdetail: ApptSearchModel = {};
  apptsearch: ApptSearchModel[] = [];
  //om
  blockTimes: blockTimeModel[] = [];
  appts: OpdAppointmentsModel[] = [];
  patients: PatientDetailModel[] = [];
  doctors: UserTypeList[] = [];
  appointments: AppointmentsModel[] = [];
  countries: CountryModel[] = [];
  states: statemodel[] = [];
  states2: statemodel[] = [];
  districts: DistrictModel[] = [];
  districts2: DistrictModel[] = [];
  cities: CityModel[] = [];
  cities2: CityModel[] = [];
  areas: AreaModel[] = [];
  areas2: AreaModel[] = [];
  datasendsms: SmsSendModel = {};
  SmsSendWhatApp: SmsSendWhatAppModel = {};
  is_nameEdit: boolean = false;
  is_surNameEdit: boolean = false;
  public checkshort: boolean = false;
  public pendingAppointment: boolean = false;
  public patientbarcodecheck: boolean = false;
  public patientregistrikerprint: boolean = false;
  public whatsappEnable: boolean = false;
  public checkAdmissionId: boolean = false;
  public matclounwidth: any = 3;
  initials: InitialsModel[] = [];
  futureApptCount = 0;
  PatientpartyId: number;
  public enableBarSticker: boolean = false;
  public appoitnmentusername: any = null;
  //8
  GroupList: OtherInfoddModel[] = [];
  //13
  GetSource: OtherInfoddModel[] = [];
  //7
  GetDisability: OtherInfoddModel[] = [];
  //14
  GetVIP: OtherInfoddModel[] = [];
  //12
  GetReligion: OtherInfoddModel[] = [];
  //6
  MaritalStatus: OtherInfoddModel[] = [];
  //9
  GetBloodgroup: OtherInfoddModel[] = [];
  //10
  GetLaungauge: OtherInfoddModel[] = [];
  //11
  GetOccupation: OtherInfoddModel[] = [];

  GetNationality: OtherInfoddModel[] = [];


  personmaster: PersonMasterModel[] = [];

  partymaster: PartyMasterModel[] = [];

  examination_details: examinationModel[] = [];

  billsummary: BillsummaryModel[] = [];

  surgeory_advised: surgeory_advised_Model[] = [];

  surgeory_done: surgeory_done_Model[] = [];

  dis_state_countryid_obj: Dist_State_CountryID_Model[] = [];
  dis_state_countryid_obj2: Dist_State_CountryID_Model[] = [];

  public blockTimeValues: blockTimeModel[] = [];
  public blockTimeSingleValue: blockTimeModel = {};

  public timevalues: cancelModel[] = [];
  public timeSingleValue: cancelModel = {};
  patientn: any;
  public PatientisExpire: boolean;
  public ipdRegistrationDetail: any = [];
  documentrul: any = [];
  public mainUrl: any;
  public url = "";
  public appSelectDate = new Date();
  public nationalityname: any;
  public PrintTypeSocket: any = 0;
  public selectedValue: string = 'Aadhaar Card No.';
  nextReview: string;
  nextReviewNote: string;
  nextReviewUnit: string;
  public content = new BehaviorSubject<string>('0');
  public share = this.content.asObservable();
  ipdId: any;
  opdvisit_list = [];
  patInfoDetails: PatientDetailModel = {};
  public allUserArray: any = [];
  public showspinner = false;
  constructor(private http: HttpClient, private dashboardService: DashboardService,
    private dialog: MatDialog, private authService: AuthService, private router: Router,
    private datePipe: DatePipe, public appservice: AppointmentService, private billingservice: BillingserviceService, private webSocketService: WebSocketService

  ) {
    this.getpersonmaster('REGISTRATION', 0);
    this.getpartymaster();
    this.get_otherinformation_tab_dd('GROUP');
    this.get_otherinformation_tab_dd('MARITALSTATUS');
    this.get_otherinformation_tab_dd('OCCUPATION');
    this.get_otherinformation_tab_dd('NATIONALITY');
    this.getinitials();
  }

  get_top200_byname(pname: string) {
    if (pname) {
      return this.http.get<any>(this.dashboardService.newbaseUrl + "Patientregistration/GetTopName/" + pname);
    }


  }
  getAllPateintSearch(startwith: any, searchtype: any, searchName: any, orderby: any) {
    return this.http.get<any>(this.dashboardService.newbaseUrl + "Patientregistration/GetPatientBySearchTypeBySearchNameByValueOrderBy/" + startwith + "/" + searchtype + "/" + searchName + "/" + orderby);
  }
  getSearchbyType(pname: string, searchtype: any, PhoneNo: any, UHID: any, OLDUHID: any) {
    if (pname || PhoneNo || UHID || OLDUHID) {
      return this.http.get<any>(this.dashboardService.newbaseUrl + "Patientregistration/GetTopName/" + pname + "/" + searchtype + "/" + PhoneNo + "/" + UHID + "/" + OLDUHID + "/ASC");
    }
  }

  set_age(patientid: number) {
    this.http.get<any>(this.dashboardService.newbaseUrl + "PatientRegistration/ShowAge/" + patientid).subscribe(
      data => this.success_set_age(data), err => this.failed_set_age(err)
    )
  }
  success_set_age(data) {
    this.patientdetails.ageYear = data.year;
    this.patientdetails.ageMonth = data.month;
    this.patientdetails.ageDays = data.day;

    // this.openSnackBar("patient's age updated successfully", "OK");
    console.log("set age data " + data.year);
    //this.openSnackBar("set age data " + data[0], "OK");
  }
  failed_set_age(err) {
    if (err.status == 403) {
      this.openSnackBar("You Don't have Permission", "OK");
    } else if (err.error.statusCode == 422) {
      this.openSnackBar(err.error.message, "OK");
    } else {
      this.openSnackBar("API Failed", "OK");
    }
  }

  //om  -08/12/2020
  getfutureAppt() {
    return this.http.get<any>(this.dashboardService.newbaseUrl + "OpdAppointment/GetFutureAppt/" + this.apptdetail.fkRegId);
  }
  get_futureApptCount() {

    this.http.get<any>(this.dashboardService.newbaseUrl + "OpdAppointment/GetFutureAppt/" + this.apptdetail.fkRegId)
      .subscribe(

        data => this.success_appt_count(data), err => this.error_appt_count(err)

      )
  }
  success_appt_count(data) {

    this.futureApptCount = data;


  }
  error_appt_count(err) {
    if (err.status == 403) {
      this.openSnackBar("You Don't have Permission", "OK");
    } else if (err.error.statusCode == 422) {
      this.openSnackBar(err.error.message, "OK");
    } else {
      this.openSnackBar("API Failed", "OK");
    }

  }

  updateage_allplaces(patientid: number, dob: any) {
    // 
    if (patientid) {
      this.http.get(this.dashboardService.newbaseUrl + "Patientregistration/UpdateAge/" + patientid + "/" + dob).subscribe(
        data => this.success_updateage(data, patientid), err => this.failed_updateage(err));

    }
    else {
      this.openSnackBar("Please Select Patient ", "OK");
    }

  }
  success_updateage(data, patientid) {
    // console.log("pat id " + patientid);
    this.set_age(patientid);
    this.openSnackBar("patient's age updated successfully", "OK");
  }
  failed_updateage(err) {
    if (err.status == 403) {
      this.openSnackBar("You Don't have Permission", "OK");
    } else if (err.error.statusCode == 422) {
      this.openSnackBar(err.error.message, "OK");
    } else {
      this.openSnackBar("API Failed", "OK");
    }
  }

  getoldphoto() {

    if (this.patientdetails.pkRegId) {
      //  return this.http.get<any>(this.dashboardService.newbaseUrl + "PatientRegistration/GetAllOldPhoto/" + this.patientdetails.pkRegId);
      return this.http.get<any>(this.dashboardService.newbaseUrl + "DocumentUpload/GetPatientDocumentDetailByRegIdByBranchIdByDocumentType/" + this.patientdetails.pkRegId + '/' + this.authService.Loggeduser.branchid + '/' + 'PATIENTPHOTO');
    }
    else {
      this.openSnackBar("Please Select Patient First", "OK");
    }
  }

  get_patient_docs() {
    this.http.get<any>(this.dashboardService.newbaseUrl + "Patientregistration/GetAllFiles/"
      + this.patientdetails.pkRegId).subscribe(
        data => this.successdocs(data), err => this.faileddocs(err)
      )
  }
  successdocs(data) {

    this.dialog.closeAll();
    this.dataSource = data;
  }
  faileddocs(err) {

  }

  get_patient_docurl() {
    this.http.get<any>(this.dashboardService.newbaseUrl + "Common/GetApplicationSetting/" + this.authService.Loggeduser.branchid).subscribe(
      data => this.successdocsurl(data), err => this.faileddocsurl(err)
    )
  }
  successdocsurl(data) {

    this.documentrul = data;
    var urldoc = this.documentrul.filter(item => item?.propertyName == "MainImagePathWebNetram")
    this.mainUrl = urldoc[0]?.propertyValue;
    var barcodecheck = this.documentrul.filter(item => item?.propertyName == "Patientsticker_barcode")
    if (barcodecheck[0]?.propertyValue == "Y") {
      this.patientbarcodecheck = true;
    } else {
      this.patientbarcodecheck = false;
    }
    var barcodetype = this.documentrul.filter(item => item?.propertyName == "PrintTypeSocket")
    if (barcodetype[0]?.propertyValue == "Barcode") {
      this.PrintTypeSocket = 1;
    } else {
      this.PrintTypeSocket = 0;
    }
    var strickerprint = this.documentrul.filter(item => item?.propertyName == "PatientStickerRegistration")
    if (strickerprint[0]?.propertyValue == "Y") {
      this.patientregistrikerprint = true;
    } else {
      this.patientregistrikerprint = false;
    }
    var whatsappenable = this.documentrul.filter(item => item?.propertyName == "Whatsapp");
    if (whatsappenable[0]?.propertyValue == "Y") {
      this.whatsappEnable = true;
    } else {
      this.whatsappEnable = false;
    }

  }
  faileddocsurl(err) {

  }

  get_old_photo() {
    this.url = "";
    if (this.authService.webstorageConfigobj.storageType.toLowerCase() == 'imageserver') {
      this.getoldphoto().subscribe((data: any) => {
        this.dataSource = data;
        if (this.dataSource.length > 0) {
          if (this.dataSource.length > 0) {
            var mainimagepath = this.documentrul.filter(item => item?.propertyName.toLowerCase() == "mainimagepath");
            if (mainimagepath.length > 0) {
              const msg = { "message": "UPLOADFILE", "ACTIONTYPE": "VIEWFILE", "DOCUMENTNAME": this.dataSource[0].documentName, "DOCUMENTTYPE": this.dataSource[0].documentType.toUpperCase(), "BranchId": this.authService.Loggeduser.branchid.toString(), "PATIENTID": this.dataSource[0].fk_RegId.toString(), "MAINIMAGEPATH": mainimagepath[0]?.propertyValue, }
              this.webSocketService.sendMessage(msg);
              this.webSocketService.getMessages().subscribe(
                (message: any) => {
                  const filedat = message;
                  if (Array.isArray(filedat)) {
                    this.url = message[0].fbLong ? message[0].fbLong : message[0].documentURL + "?" + Math.floor(Math.random() * 100) + 1;
                  }else{
                      this.url = "./assets/img/noimage.png" + "?" + Math.floor(Math.random() * 100) + 1;
                  }

                }, err => {
                  this.dashboardService.openSnackBar("Please set server configuration", "OK");
                });
            } else {
              this.dashboardService.openSnackBar("Please set MainImagePath", "OK");
            }
          } else {
            this.url = "./assets/img/noimage.png" + "?" + Math.floor(Math.random() * 100) + 1;
          }
        } else {
          this.url = "./assets/img/noimage.png" + "?" + Math.floor(Math.random() * 100) + 1;
        }
      }, err => {
        this.url = "./assets/img/noimage.png" + "?" + Math.floor(Math.random() * 100) + 1;
      });
     
    } else {
      this.getoldphoto().subscribe((data: any) => {
        if (data.length > 0) {
          this.url = data[0].fbLong ? data[0].fbLong : data[0].documentURL + "?" + Math.floor(Math.random() * 100) + 1;
        } else {
          this.url = "./assets/img/noimage.png" + "?" + Math.floor(Math.random() * 100) + 1;
        }
      }, err => {
        this.url = "./assets/img/noimage.png" + "?" + Math.floor(Math.random() * 100) + 1;
      });
    }


  }
  success_old_photo(data) {

    if (data.statusCode == 1) {
      this.url = data[0].fbLong ? data[0].fbLong : data[0].documentURL + "?" + Math.floor(Math.random() * 100) + 1;
    } else {
      this.url = "./assets/img/noimage.png" + "?" + Math.floor(Math.random() * 100) + 1;
    }

  }
  failed_old_photo(err) {

    this.url = "./assets/img/noimage.png" + "?" + Math.floor(Math.random() * 100) + 1;
  }

  //delete photos
  // deletepatientphoto(patid:any){

  //   if(patid){
  //     this.http.get<any>(this.dashboardService.baseUrl + "PatientRegistration/DeletePhoto/" + patid).
  //     subscribe(data => this.success_delete_image(data), err => this.failed_delete_image(err));

  //   }
  //   else{
  //     this.openSnackBar("Please Select Patient First", "OK");
  //   }
  // }
  // success_delete_image(data){
  //    console.log(data);
  // }

  // failed_delete_image(err){

  // }

  get_surgeory_done(regid) {
    return this.http.get<any>(this.dashboardService.newbaseUrl + "VisitMaster/GetDoneSurgery/" +
      regid + '/' + this.authService.Loggeduser.specialityId);
  }

  get_surgeory_advised(regid) {
    return this.http.get<any>(this.dashboardService.newbaseUrl + "VisitMaster/GetSurgery/" +
      regid + '/' + this.authService.Loggeduser.specialityId)
  }


  get_billsummary(regid) {
    return this.http.get<any>(this.dashboardService.newbaseUrl + "VisitMaster/GetBills/" +
      regid + '/' + this.authService.Loggeduser.specialityId)
  }

  get_examination_details(regid) {
    return this.http.get<any>(this.dashboardService.newbaseUrl + "VisitMaster/GetExam/" +
      regid + '/' + this.authService.Loggeduser.specialityId)
  }

  callForkjoin(regid: any) {
    forkJoin({
      surgeorydata: this.get_surgeory_done(regid),
      surgeory_adviseddata: this.get_surgeory_advised(regid),
      billsummarydata: this.get_billsummary(regid),
      examinationdata: this.get_examination_details(regid),
    }).subscribe(
      (results: any) => {
        this.surgeory_done = results.surgeorydata;
        this.surgeory_advised = results.surgeory_adviseddata;
        this.billsummary = results.billsummarydata;
        if (results.billsummarydata.length > 0) {
          this.billsummary = this.billsummary.slice().reverse();
        }
        this.examination_details = results.examinationdata;
        this.nextReview = this.examination_details.length == 0 ? '' : this.examination_details[0].nextReview;
        this.nextReviewNote = this.examination_details.length == 0 ? '' : this.examination_details[0].nextReviewNote;
        this.nextReviewUnit = this.examination_details.length == 0 ? '' : this.examination_details[0].nextReviewUnit;

      },
      (err) => {

        this.dashboardService.openSnackBar("API Failed", "ok");
      }
    );
  }
  delete_patient() {
    this.dashboardService.showspinner = true;
    this.http.get<any>(this.dashboardService.newbaseUrl + "patientregistration/Delete/" +
      this.patientdetails.pkRegId).
      subscribe(data => this.success_patient_delete(data), err => this.failed_patient_delete(err));
  }
  success_patient_delete(date) {
    this.dashboardService.showspinner = false;
    this.openSnackBar("patient deleted successfully", "Ok");
    this.patientdetails = {};
  }

  failed_patient_delete(err) {
    this.dashboardService.showspinner = false;
    this.openSnackBar("patient deleted successfully", "Ok");
    this.patientdetails = {};
  }

  get_pat_sdate_edate(sdate: string, edate: string) {
    return this.http.get<any>(this.dashboardService.newbaseUrl + "PatientRegistration/SearchPatient/" +
      sdate + "/" + edate)
  }
  //new APi intergrate
  get_Zone_data_sdate_edate(sdate: string, edate: string, flag) {
    // 
    return this.http.get<any>(this.dashboardService.newbaseUrl + "Register/GetPatientCitywiseRegData/?" + "Fromdate=" + sdate + "&Todate=" + edate + "&Flag=" + flag)
  }
  get_appt_sdate_edate(sdate: string, edate: string) {
    // alert(sdate);
    //alert(edate);
    //alert(+this.authService.Loggeduser.branchid);

    return this.http.get<any>(this.dashboardService.newbaseUrl + "OpdAppointment/AppListFromToDate/" +
      sdate + "/" + edate + "/" + this.authService.Loggeduser.branchid)
  }
  // get_appt_sdate_edate(sdate: string, edate: string) {
  //   return this.http.get<any>(this.dashboardService.baseUrl + "OpdAppointment/AppListFromToDate/" +
  //     sdate + "/" + edate+ "/" +this.authService.Loggeduser.branchid)
  // } 
  get_city_district_state_country(cityid: number, option: number) {
    this.config_cityid = cityid;

    // let apipath = "http://172.29.56.6:8090/api/"
    this.http.get<any>(this.dashboardService.newbaseUrl + "CityMaster/getAll/" + cityid).
      subscribe(data => this.success_dis_state_countryid(data, option),
        err => this.failed_dis_state_countryid(err))
  }
  //om
  get_appt_city_district_state_country(cityid: number, option: number) {
    console.log('cityid', cityid)

    //alert("In main Function");
    // let apipath = "http://172.29.56.6:8090/api/"
    if (cityid) {
      this.http.get<any>(this.dashboardService.newbaseUrl + "CityMaster/getALL/" + cityid).
        subscribe(data => this.success_appt_dis_state_countryid(data, option),
          err => this.failed_dis_state_countryid(err))
    }

  }
  //om
  success_appt_dis_state_countryid(data, option: number) {

    // when this method called for permanent address
    if (option == 1) {
      this.dis_state_countryid_obj = data;
      this.countryid = this.dis_state_countryid_obj[0].countryId;
      //fill state dd
      this.getappstates(this.countryid, 1);
    }
    // when this method called for local address
    else {
      // this.dis_state_countryid_obj2 = data;

      //this.localcountryid = this.dis_state_countryid_obj2[0].countryId;

      //fill state dd
      //this.getstates(this.localcountryid, 2);
    }


    // console.log ("got sucess" + this.dis_state_countryid_obj[0].cityName);
  }
  //

  success_dis_state_countryid(data, option: number) {

    // when this method called for permanent address
    if (option == 1) {
      this.dis_state_countryid_obj = data;

      this.countryid = this.dis_state_countryid_obj[0]?.countryId;

      //fill state dd
      this.getstates(this.countryid, 1);
    }
    // when this method called for local address
    else {
      this.dis_state_countryid_obj2 = data;
      if (this.dis_state_countryid_obj2[0].countryId == null || this.dis_state_countryid_obj2[0].countryId == undefined) {
        alert("Country Not Found!");
        return;
      }
      this.localcountryid = this.dis_state_countryid_obj2[0].countryId;

      //fill state dd
      this.getstates(this.localcountryid, 2);
    }


    // console.log ("got sucess" + this.dis_state_countryid_obj[0].cityName);
  }
  failed_dis_state_countryid(err) {

  }

  get_top_200_patients() {
    return this.http.get<any>(this.dashboardService.newbaseUrl + "PatientRegistration/GetTopPatients");
  }

  //om
  updateappt(branchid) {
    // this.open_loader_Dialog();
    this.apptdetail.fkBranchId = branchid;
    this.apptdetail.dob = this.datePipe.transform(this.apptdetail.dob, "yyyy-MM-dd");
    this.apptdetail.apptDate = this.appservice.selectedDate;
    if (this.apptdetail.lastName == null) {
      this.apptdetail.lastName = '';
    }
    this.apptdetail.fkCityId = this.apptdetail.fkCityId ? this.apptdetail.fkCityId : null;
    this.apptdetail.address = this.apptdetail.address == null ? this.apptdetail.address = '' : this.apptdetail.address
    // this.apptdetail.apptDate=this.datePipe.transform(this.appservice.selectedDate,"yyyy-MM-dd");
    this.apptdetail.isActive = "true";
    this.apptdetail.bookingDate = this.datePipe.transform(this.bookingDate, "yyyy-MM-dd");
    this.apptdetail.daySrNo = 1;
    this.apptdetail.fkCity = null;
    this.apptdetail.isConfirm = "false";
    this.apptdetail.isCancelled = "false";
    this.apptdetail.tokenNo = 1;
    this.apptdetail.apptTime = this.convertTo24Hour(this.apptdetail.apptTime);
    this.apptdetail.fkForBranchId = branchid;
    this.apptdetail.fkCreatedById = this.authService.Loggeduser.userid;
    this.apptdetail.mobileNo = this.apptdetail.mobileNo;
    this.apptdetail.contactNo = this.apptdetail.mobileNo;
    this.apptdetail.FK_PartyId = this.apptdetail.fkPartyId;
    this.apptdetail.Fk_SpecialityIdModule = this.authService.Loggeduser.specialityId;
    this.apptdetail.fkServiceId = this.apptdetail.fkServiceId != 0 ? this.apptdetail.fkServiceId : null
    if (this.apptdetail.lastName == null) {
      this.apptdetail.lastName = '';
    }
    this.http.post<any>(this.dashboardService.newbaseUrl + "OpdAppointment/UpdateAppt",
      this.apptdetail).

      subscribe(data => this.success_appt_update(data, branchid), err => this.failed_appt_update(err));

  }
  //om
  success_appt_update(data, branchid) {
    this.RefreshCount = this.RefreshCount + 1;
    // this.dialog.closeAll();
    this.appservice.DoctorId = this.apptdetail.fkConsultantId;

    //get patient docs
    // this.get_patient_docs();
    this.apptdetail.pkAppointmentId = data;

    //this.patientdetails.pkRegId = data;
    this.openSnackBar("Record Updated Successfully", "Ok");
    this.appservice.showRec(branchid);
    this.showspinner = false;
  }
  //om
  failed_appt_update(err) {
    debugger
    this.showspinner = false;
    if (err.status == 403) {
      this.openSnackBar("You Don't have Permission", "OK");
    } else if (err.error.statusCode == 422) {
      this.openSnackBar(err.error.message, "OK");
    } else {
      this.openSnackBar("API Failed", "OK");
    }
  }

  updatepatient() {
    // 
    this.open_loader_Dialog();
    if (this.patientdetails.careofName == undefined || this.patientdetails.careofName == "") {
      this.patientdetails.careofType = "";
    }
    this.patientdetails.fkBranchId = this.authService.Loggeduser.branchid;

    if (this.patientdetails.lastName == null) {
      this.patientdetails.lastName = '';
    }
    this.patientdetails.fkPartyId = this.patientdetails.fkPartyId != 0 ? this.patientdetails.fkPartyId : null;
    this.patientdetails.fkReferredbyId = this.patientdetails.fkReferredbyId != 0 ? this.patientdetails.fkReferredbyId : null;
    this.patientdetails.fkLareaId = this.patientdetails.fkLareaId != 0 ? this.patientdetails.fkLareaId : null;
    this.patientdetails.fkLcityId = this.patientdetails.fkLcityId != 0 ? this.patientdetails.fkLcityId : null;
    this.patientdetails.fkPcityId = this.patientdetails.fkPcityId != 0 ? this.patientdetails.fkPcityId : null;
    this.patientdetails.fkPareaId = this.patientdetails.fkPareaId != 0 ? this.patientdetails.fkPareaId : null;
    this.patientdetails.fkMaritalId = this.patientdetails.fkMaritalId != 0 ? this.patientdetails.fkMaritalId : null;
    this.patientdetails.fkBloodGroupId = this.patientdetails.fkBloodGroupId != 0 ? this.patientdetails.fkBloodGroupId : null;
    this.patientdetails.fkDisablityId = this.patientdetails.fkDisablityId != 0 ? this.patientdetails.fkDisablityId : null;
    this.patientdetails.fkGroupId = this.patientdetails.fkGroupId != 0 ? this.patientdetails.fkGroupId : null;
    this.patientdetails.fkLanguageId = this.patientdetails.fkLanguageId != 0 ? this.patientdetails.fkLanguageId : null;
    this.patientdetails.fkNationalityId = this.patientdetails.fkNationalityId != 0 ? this.patientdetails.fkNationalityId : null;
    this.patientdetails.fkOccupationId = this.patientdetails.fkOccupationId != 0 ? this.patientdetails.fkOccupationId : null;
    this.patientdetails.fkReligionId = this.patientdetails.fkReligionId != 0 ? this.patientdetails.fkReligionId : null;
    this.patientdetails.fkSourceId = this.patientdetails.fkSourceId != 0 ? this.patientdetails.fkSourceId : null;
    this.patientdetails.fkViprefId = this.patientdetails.fkViprefId != 0 ? this.patientdetails.fkViprefId : null;
    this.patientdetails.fkReferredbyIdLatest = this.patientdetails.fkReferredbyIdLatest != 0 ? this.patientdetails.fkReferredbyIdLatest : null;
    this.patientdetails.FK_ModifiedByID = this.authService.Loggeduser.userid;
    this.patientdetails.ModifiedDateTime = this.authService.localDate;

    this.http.post<any>(this.dashboardService.newbaseUrl + "PatientRegistration/UpdatePatient",
      this.patientdetails).

      subscribe(data => this.success_patient_update(data), err => this.failed_patient_update(err));
  }
  success_patient_update(data: any) {
    console.log(data);
    this.patientdetails = data;
    if (this.patientdetails.firstName == undefined) {
      this.patientn = this.patientdetails.firstName;
    } else {
      this.patientn = this.patientdetails.firstName + ' ' + this.patientdetails.lastName;
      console.log(this.patientn);
    }
    this.dialog.closeAll();

    //get patient docs
    this.get_patient_docs();
    this.getpatientdetails(this.patientdetails.pkRegId, 0);
    // console.log("patient updated" + JSON.stringify(data));
    this.PatientpartyId = this.patientdetails.fkPartyId
    // console.log("patient PatientpartyId" +  this.PatientpartyId);
    //this.patientdetails.pkRegId = data;
    this.openSnackBar("Patient updated successfully", "Ok");

    if (this.flag == "fromopdvisit") {

      this.flag = "";
      this.router.navigate(['/layout/OpdVisit', "fromregister"], { replaceUrl: true });
    }
  }
  failed_patient_update(err) {
    this.dialog.closeAll();
    if (err.status == 403) {
      this.openSnackBar("You Don't have Permission", "OK");
    }
    else if (err.error.statusCode == 422) {
      this.openSnackBar(err.error.message, "OK");
    }
    else {
      this.openSnackBar("API Failed", "OK");
    }
  }

  open_loader_Dialog(): void {

    const dialogRef = this.dialog.open(SiteloaderComponent, {
      width: '300px',
      panelClass: "site-loader",
      data: {
        // id: this.dashboardService.pid,
        //userid: this.authService.Loggeduser.userid
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      //pid = result;
    });
  }

  savepatientdetails() {

    if (this.checkshort == false) {
      this.open_loader_Dialog();
    }
    if (this.patientdetails.careofName == undefined) {
      this.patientdetails.careofType = "";
    }
    if (this.patientdetails.lastName == null) {
      this.patientdetails.lastName = '';
    }
    this.patientdetails.fkBranchId = this.authService.Loggeduser.branchid;
    this.patientdetails.pkRegId = 0;

    this.set_date_and_time();
    if (this.patientdetails.mobileNo == undefined || this.patientdetails.mobileNo == "") {
      this.patientdetails.mobileNo = this.apptdetail.mobileNo;

    } else {
      this.patientdetails.mobileNo
    }

    this.patientdetails.EntryFrom = "webNetram";
    this.patientdetails.regDate = this.authService.getServerDate;
    this.patientdetails.FK_CreatedbyID = this.authService.Loggeduser.userid;
    this.patientdetails.fkPartyId = this.patientdetails.fkPartyId != 0 ? this.patientdetails.fkPartyId : null;
    this.patientdetails.fkReferredbyId = this.patientdetails.fkReferredbyId != 0 ? this.patientdetails.fkReferredbyId : null;
    this.patientdetails.fkLareaId = this.patientdetails.fkLareaId != 0 ? this.patientdetails.fkLareaId : null;
    this.patientdetails.fkLcityId = this.patientdetails.fkLcityId != 0 ? this.patientdetails.fkLcityId : null;
    this.patientdetails.fkPcityId = this.patientdetails.fkPcityId != 0 ? this.patientdetails.fkPcityId : null;
    this.patientdetails.fkPareaId = this.patientdetails.fkPareaId != 0 ? this.patientdetails.fkPareaId : null;
    this.patientdetails.fkMaritalId = this.patientdetails.fkMaritalId != 0 ? this.patientdetails.fkMaritalId : null;
    this.patientdetails.fkBloodGroupId = this.patientdetails.fkBloodGroupId != 0 ? this.patientdetails.fkBloodGroupId : null;
    this.patientdetails.fkDisablityId = this.patientdetails.fkDisablityId != 0 ? this.patientdetails.fkDisablityId : null;
    this.patientdetails.fkGroupId = this.patientdetails.fkGroupId != 0 ? this.patientdetails.fkGroupId : null;
    this.patientdetails.fkLanguageId = this.patientdetails.fkLanguageId != 0 ? this.patientdetails.fkLanguageId : null;
    this.patientdetails.fkNationalityId = this.patientdetails.fkNationalityId != 0 ? this.patientdetails.fkNationalityId : null;
    this.patientdetails.fkOccupationId = this.patientdetails.fkOccupationId != 0 ? this.patientdetails.fkOccupationId : null;
    this.patientdetails.fkReligionId = this.patientdetails.fkReligionId != 0 ? this.patientdetails.fkReligionId : null;
    this.patientdetails.fkSourceId = this.patientdetails.fkSourceId != 0 ? this.patientdetails.fkSourceId : null;
    this.patientdetails.fkViprefId = this.patientdetails.fkViprefId != 0 ? this.patientdetails.fkViprefId : null;
    this.patientdetails.regTime = new Date().toTimeString().split(" ")[0];
    this.http.post<any>(this.dashboardService.newbaseUrl + "PatientRegistration/InsertPatient"
      , this.patientdetails).
      subscribe(data => this.success_patient_save(data), err => this.failed_patient_save(err));
  }

  saveapptdetails(branchid) {
    if (this.apptdetail.ageYear == 0) {
      if (this.apptdetail.ageMonth != 0 || this.apptdetail.ageMonth != null || this.apptdetail.ageDays != 0 || this.apptdetail.ageDays != null) {
        this.apptdetail.ageYear = 1;
      }
    }
    this.apptdetail.fkBranchId = branchid;
    this.apptdetail.dob = this.datePipe.transform(this.apptdetail.dob, "yyyy-MM-dd");
    this.apptdetail.apptDate = this.appservice.selectedDate;
    if (this.apptdetail.lastName == null) {
      this.apptdetail.lastName = '';
    }
    this.apptdetail.fkCityId = this.apptdetail.fkCityId ? this.apptdetail.fkCityId : null;
    this.apptdetail.address = this.apptdetail.address == null ? this.apptdetail.address = '' : this.apptdetail.address
    // this.apptdetail.apptDate=this.datePipe.transform(this.appservice.selectedDate,"yyyy-MM-dd");
    this.apptdetail.isActive = "true";
    this.apptdetail.bookingDate = this.datePipe.transform(this.bookingDate, "yyyy-MM-dd");
    this.apptdetail.daySrNo = 1;
    this.apptdetail.fkCity = null;
    this.apptdetail.isConfirm = "false";
    this.apptdetail.isCancelled = "false";
    this.apptdetail.tokenNo = 1;
    this.apptdetail.apptTime = this.convertTo24Hour(this.apptdetail.apptTime);
    this.apptdetail.fkForBranchId = branchid;
    this.apptdetail.fkCreatedById = this.authService.Loggeduser.userid;
    this.apptdetail.mobileNo = this.apptdetail.mobileNo;
    this.apptdetail.contactNo = this.apptdetail.mobileNo;
    this.apptdetail.FK_PartyId = this.apptdetail.fkPartyId;
    this.apptdetail.pkAppointmentId = 0;
    this.apptdetail.fK_CreatedbyID = this.authService.Loggeduser.userid;
    this.apptdetail.Fk_SpecialityIdModule = this.authService.Loggeduser.specialityId;
    this.apptdetail.fkServiceId = this.apptdetail.fkServiceId != 0 ? this.apptdetail.fkServiceId : null

    this.RefreshCount = this.RefreshCount + 1;
    this.http.post<any>(this.dashboardService.newbaseUrl + "OpdAppointment/InsertAppt"
      , this.apptdetail).
      subscribe(data => this.success_appt_save(data, branchid), err => this.failed_appt_save(err));

  }

  relaseBlockAppoitment(blocktime) {
    return this.http.post<any>(this.dashboardService.newbaseUrl + "AppointmentBlock/ReleaseAll"
      , blocktime);
  }
  //Relase All
  releaseAll() {
    this.http.post<any>(this.dashboardService.newbaseUrl + "AppointmentBlock/ReleaseAll"
      , this.blockTimeValues).
      subscribe(data => this.success_releaseAll_save(data), err => this.failed_releaseAll_save(err));
  }
  success_releaseAll_save(data) {
    // this.blockTimeDetail.pkTranId = data;
    this.openSnackBar("Appointments are Released", "ÖK");
    this.blockTimeValues = [];
  }
  failed_releaseAll_save(err) {
    //alert("Failed");
  }

  //


  blockAll() {
    // alert("In Final block");
    this.http.post<any>(this.dashboardService.newbaseUrl + "AppointmentBlock/BlockAll"
      , this.blockTimeValues).
      subscribe(data => this.success_blockAll_save(data), err => this.failed_blockAll_save(err));
  }
  success_blockAll_save(data) {
    // this.blockTimeDetail.pkTranId = data;
    this.openSnackBar("All Appointments Blocked", "ÖK");
    this.blockTimeValues = [];
  }
  failed_blockAll_save(err) {
    //alert("Failed");
  }
  //
  cancelAllAppt() {
    this.timevalues.map(item => item.cancelRemarks = this.timeSingleValue.cancelRemarks);
    return this.http.post<any>(this.dashboardService.newbaseUrl + "OpdAppointment/CancelAll"
      , this.timevalues);
  }
  cancelAll() {
    //    alert("Ruko");
    console.log("Time-" + this.timevalues);
    //   alert("End");

    // console.log(this.blockTimeValues);
    this.http.post<any>(this.dashboardService.newbaseUrl + "OpdAppointment/CancelAll"
      , this.timevalues).
      subscribe(data => this.success_cancellAll_save(data), err => this.failed_cancellAll_save(err));
  }

  success_cancellAll_save(data) {
    // this.blockTimeDetail.pkTranId = data;

    this.openSnackBar("Appointment is Cancelled", "ÖK");

  }
  failed_cancellAll_save(err) {
    //alert("Failed");
  }
  //om
  saveBlockAppt() {
    this.apptdetail.dob = this.datePipe.transform(this.apptdetail.dob, "yyyy-MM-dd");
    this.apptdetail.apptDate = this.appservice.selectedDate;
    this.apptdetail.apptDate = this.datePipe.transform(this.appservice.selectedDate, "yyyy-MM-dd");
    //om
    this.blockTimeDetail.apptDate = this.apptdetail.apptDate;
    this.blockTimeDetail.apptTime = this.convertTo24Hour(this.blockApptTime); //this.blockApptTime.substring(0,this.blockApptTime.length-2)
    // this.blockTimeDetail.entryDatetime=date();
    this.blockTimeDetail.fkBranchId = this.authService.Loggeduser.branchid;
    //alert(this.DoctorId);
    this.blockTimeDetail.fkDoctorId = this.DoctorId;
    this.blockTimeDetail.isActive = "true";
    this.blockTimeDetail.pkTranId = 0;
    this.blockTimeDetail.fkCreatedById = this.authService.Loggeduser.userid;
    this.blockTimeDetail.EntryDateTime = this.datePipe.transform(this.currDate, "MM-dd-yyyy")
    this.http.post<any>(this.dashboardService.newbaseUrl + "AppointmentBlock/BlockApp"
      , this.blockTimeDetail).
      subscribe(data => this.success_block_save(data), err => this.failed_appt_save(err));
  }
  //om


  cancelAppt() {
    //this.apptdetail.dob=this.datePipe.transform( this.apptdetail.dob,"yyyy-MM-dd");
    // this.apptdetail.apptDate=this.appservice.selectedDate;
    // this.apptdetail.apptDate=this.datePipe.transform(this.appservice.selectedDate,"yyyy-MM-dd");
    //om
    //this.blockTimeDetail.apptDate= this.apptdetail.apptDate;
    //this.blockTimeDetail.apptTime=this.blockApptTime.substring(0,this.blockApptTime.length-2)
    //this.blockTimeDetail.apptTime=this.convertTo24Hour(this.blockApptTime);
    // this.blockTimeDetail.entryDatetime=date();
    //this.authService.Loggeduser.userid;
    //alert(this.DoctorId);
    //this.blockTimeDetail.fkDoctorId =   this.DoctorId;
    //this.blockTimeDetail.isActive="false";
    //this.blockTimeDetail.pkTranId=0;
    //this.blockTimeDetail.fkCreatedById=this.authService.Loggeduser.userid;
    //this.blockTimeDetail.entryDatetime=  this.datePipe.transform(this.currDate, "MM-dd-yyyy")
    // alert("to be saved");
    this.http.get<any>(this.dashboardService.newbaseUrl + "OpdAppointment/CancelApp/" + this.authService.Loggeduser.userid + "/" + this.appId).
      subscribe(data => this.cancel_save(data), err => this.cancel_failed_save(err));
  }
  cancel_save(data) {
    // alert("To be cancelled");

    this.blockTimeDetail.pkTranId = data;
    console.log(this.blockTimeDetail.pkTranId)
    this.openSnackBar("Appointment Id-" + this.appId + " Cancelled Successfully", "ÖK");

  }
  cancel_failed_save(err) {
    //  this.dialog.closeAll();
    console.log("For Appointment Id-" + this.appId + ", Cancellation Failed...");

  }

  releaseBlockAppt() {
    this.apptdetail.dob = this.datePipe.transform(this.apptdetail.dob, "yyyy-MM-dd");
    this.apptdetail.apptDate = this.appservice.selectedDate;
    this.apptdetail.apptDate = this.datePipe.transform(this.appservice.selectedDate, "yyyy-MM-dd");
    //om
    this.blockTimeDetail.apptDate = this.apptdetail.apptDate;
    //this.blockTimeDetail.apptTime=this.blockApptTime.substring(0,this.blockApptTime.length-2)
    this.blockTimeDetail.apptTime = this.convertTo24Hour(this.blockApptTime);
    // this.blockTimeDetail.entryDatetime=date();
    this.blockTimeDetail.fkBranchId = this.authService.Loggeduser.branchid;
    //alert(this.DoctorId);
    this.blockTimeDetail.fkDoctorId = this.DoctorId;
    this.blockTimeDetail.isActive = "false";
    this.blockTimeDetail.pkTranId = 0;
    this.blockTimeDetail.fkCreatedById = this.authService.Loggeduser.userid;
    this.blockTimeDetail.EntryDateTime = this.datePipe.transform(this.currDate, "MM-dd-yyyy")
    this.http.post<any>(this.dashboardService.newbaseUrl + "AppointmentBlock/ReleaseTime"
      , this.blockTimeDetail).
      subscribe(data => this.success_release_save(data), err => this.failed_release_save(err));
  }

  success_release_save(data) {
    this.blockTimeDetail.pkTranId = data;
    this.openSnackBar("Time-" + this.blockTimeDetail.apptTime + " Released Successfully", "ÖK");

  }
  failed_release_save(err) {
    //  this.dialog.closeAll();
    console.log("Time-" + this.blockTimeDetail.apptTime + " Release Failed...");

  }
  success_block_save(data) {
    this.blockTimeDetail.pkTranId = data;
    this.openSnackBar("Time-" + this.blockTimeDetail.apptTime + " Blocked Successfully", "ÖK");
    this.dialog.closeAll();

  }
  failed_block_save(err) {
    //  this.dialog.closeAll();
    console.log("Block Failed...");

  }

  set_date_and_time() {
    this.authService.serverDateTime().subscribe(data => {
      let todaysdate = data.serverDate;
      let todaytime = data.serverTime;
      this.registereddate = this.datePipe.transform(todaysdate, "MM-dd-yyyy")
      this.registeredtime = todaytime;
      this.patientdetails.regDate = this.registereddate.toString();
      this.patientdetails.regTime = this.registeredtime.toString();
    });
    //this.patientdetails.regTime = "six thirty";
    //console.log(registereddate);
    //console.log(registeredtime); 
  }

  success_appt_save(data, branchid) {
    if (data.statusCode == 1) {
      this.apptdetail.pkAppointmentId = data;
      // this.dashboardService.showspinner = false;

      // this.dialog.closeAll();
      //send sms collection
      // if (this.apptdetail.mobileNo != "" && this.apptdetail.mobileNo != null && this.apptdetail.mobileNo != undefined) {
      //   var result = this.doctors.filter(x => x.userId === this.apptdetail.fkConsultantId);

      //   this.datasendsms.PatientName = this.apptdetail.firstName + ' ' + this.apptdetail.lastName;
      //   this.datasendsms.MobileNo = this.apptdetail.mobileNo;
      //   this.datasendsms.MrdNo = this.apptdetail.fkRegId;
      //   this.datasendsms.SeqNo = null;
      //   this.datasendsms.ApptDate = this.apptdetail.apptDate;
      //   this.datasendsms.ApptTime = this.apptdetail.apptTime;
      //   this.datasendsms.ApptConsultant = result[0]?.userName;
      //   this.datasendsms.SurgeryDate = null;
      //   this.datasendsms.SurgeryTime = null;
      //   this.datasendsms.BranchId = branchid
      //   this.datasendsms.SMSType = "APPTBOOKING_NEW";
      //   this.sendSMstoPatient(this.datasendsms);
      //   this.SmsSendWhatApp.PatientName = this.apptdetail.firstName + ' ' + this.apptdetail.lastName;
      //   this.SmsSendWhatApp.MobileNo = this.apptdetail.mobileNo;
      //   this.SmsSendWhatApp.ApptDate = this.apptdetail.apptDate;
      //   this.SmsSendWhatApp.ApptTime = this.apptdetail.apptTime;
      //   this.SmsSendWhatApp.ApptConsultant = result[0]?.userName;
      //   this.SmsSendWhatApp.TransDate = this.datePipe.transform(this.authService.localDate, 'dd-MM-yyyy')
      //   this.SmsSendWhatApp.HelpLineNo = this.dashboardService.branchmansterObj.line3;
      //   this.SmsSendWhatApp.Location = this.dashboardService.branchmansterObj.line1.replaceAll(',', ' ');
      //   this.SmsSendWhatApp.HospitalName = this.authService.Loggeduser.billingcompanyname;
      //   this.SmsSendWhatApp.BranchId = branchid
      //   this.SmsSendWhatApp.SMSType = "APPTBOOKING_NEW";
      //   this.sendwhatsApp(this.SmsSendWhatApp);
      // }

      if (this.apptdetail.emailAddress != "" && this.apptdetail.emailAddress != null && this.apptdetail.emailAddress != undefined) {
        const filedata = null;
        const formData = new FormData();
        formData.append('file', filedata);
        formData.append('EmailType', 'APPTBOKING');
        formData.append('ToEmail', this.apptdetail.emailAddress);
        this.sendEmailtoPatient(formData);
      }

      this.openSnackBar("Appointment Saved Successfully", "Ok");
    }
    else {
      this.openSnackBar(data.message, "Ok");
    }
    this.appservice.showRec(branchid);
    // this.dialog.closeAll();
    this.showspinner = false;

  }
  errlist(err) {

  }

  successlist(data) {
    //alert("Aaye kya undar");
    //this.appservice.Doctor_time_info= data;
    console.log(data);
  }
  success_patient_save(data: any) {
    this.checkpatient = data;
    // if (this.patientdetails.mobileNo != "" && this.patientdetails.mobileNo != null && this.patientdetails.mobileNo != undefined) {
    // this.datasendsms.PatientName = this.patientdetails.firstName + ' ' + this.patientdetails.lastName;
    // this.datasendsms.MobileNo = this.patientdetails.mobileNo;
    // this.datasendsms.MrdNo = data;
    // this.datasendsms.SeqNo = null;
    // this.datasendsms.ApptDate = null;
    // this.datasendsms.ApptTime = null;
    // this.datasendsms.ApptConsultant = null;
    // this.datasendsms.SurgeryDate = null;
    // this.datasendsms.SurgeryTime = null;
    // this.datasendsms.BranchId = this.authService.Loggeduser.branchid
    // this.datasendsms.SMSType = "NEWREGISTRATION";
    // this.sendSMstoPatient(this.datasendsms);
    //   this.datasendsms.FileName = "";
    //   this.datasendsms.FileURL = "";
    //   this.SmsSendWhatApp.PatientName = this.patientdetails.firstName + ' ' + this.patientdetails.lastName;
    //   this.SmsSendWhatApp.MobileNo = this.patientdetails.mobileNo;
    //   this.SmsSendWhatApp.TransDate = this.datePipe.transform(this.authService.localDate, 'dd-MM-yyyy')
    //   this.SmsSendWhatApp.HelpLineNo = this.dashboardService.branchmansterObj.line3;
    //   this.SmsSendWhatApp.Location = this.dashboardService.branchmansterObj.line1.replaceAll(',', ' ');
    //   this.SmsSendWhatApp.HospitalName = this.authService.Loggeduser.billingcompanyname;
    //   this.SmsSendWhatApp.MrdNo = data;
    //   this.SmsSendWhatApp.Link = '';
    //   this.SmsSendWhatApp.HospitalWebsite = '';
    //   this.SmsSendWhatApp.BranchId = this.authService.Loggeduser.branchid
    //   this.SmsSendWhatApp.SMSType = "NEWREGISTRATION";
    //   this.sendwhatsApp(this.SmsSendWhatApp);
    //   if (this.patientdetails.emailAddress != "" && this.patientdetails.emailAddress != null && this.patientdetails.emailAddress != undefined) {
    //     const filedata = null;

    //     const formData = new FormData();
    //     formData.append('file', filedata);
    //     formData.append('EmailType', 'PATIENT REGISTRATION');
    //     formData.append('ToEmail', this.patientdetails.emailAddress);
    //     this.sendEmailtoPatient(formData);
    //   }

    // }

    // this.dashboardService.showspinner = false;
    if (this.checkshort == true) {
      this.dialog.closeAll();
    }

    this.patientdetails.pkRegId = data;

    //get patient documents
    this.get_patient_docs();

    this.getpatientdetails(this.patientdetails.pkRegId, 0);

    if (this.flag_reg_from_appointments == true) {



      //update patient id in appointment table as patient id is created on fly
      this.http.get(this.dashboardService.newbaseUrl + "OpdAppointment/UpdatePtId/"
        + this.apptdetail.pkAppointmentId + "/" + this.patientdetails.pkRegId).subscribe(
          data => this.success_update_patid_app_table(data), err => this.failed_update_patid_app_table(err)
        )
      this.flag_reg_from_appointments = false;
    }
    else {
      this.openSnackBar("Patient Saved Successfully, UHID Generated "
        + this.patientdetails.pkRegId, "Ok");

      if (this.flag == "fromopdvisit") {

        this.flag = "";
        this.router.navigate(['/layout/OpdVisit', "fromregister"], { replaceUrl: true });
      }
    }


  }

  failed_patient_save(err) {
    this.dialog.closeAll();
    if (err.status == 403) {
      this.openSnackBar("You Don't have Permission", "OK");
    } else if (err.error.statusCode == 422) {
      this.openSnackBar(err.error.message, "OK");
    } else {
      this.openSnackBar("API Failed", "OK");
    }

  }

  //write sms configuration
  // sendSMstoPatient(datasms) {

  //   if (this.authService.smsConfigdata) {
  //     this.http.post<any>(this.dashboardService.newbaseUrl + "SendSMS/SendMessage"
  //       , datasms).
  //       subscribe(data => this.success_send_sms(data), err => this.failed_send_sms(err));
  //   }

  // }
  // success_send_sms(data) {

  // }
  // failed_send_sms(err) {
  //   if (err.status == 403) {
  //     this.openSnackBar("You Don't have Permission", "OK");
  //   } else {
  //     this.openSnackBar("API Failed", "OK");
  //   }
  // }
  // sendwhatsApp(data) {
  //   if (this.whatsappEnable == true) {
  //     this.http.post<any>(this.dashboardService.newbaseUrl + "SendSMS/SendWhatsApp"
  //       , data).
  //       subscribe(data => this.success_whatAPP_msg(data), err => this.failed_send_sms(err));
  //   }
  // }
  // success_whatAPP_msg(data) {
  //   console.log(data)
  // }
  //write Email COnfiguration

  //write sms configuration
  sendEmailtoPatient(datasms) {

    this.http.post<any>(this.dashboardService.newbaseUrl + "Email/Send"
      , datasms).
      subscribe(data => this.success_send_Email(data), err => this.failed_send_Email(err));
  }
  success_send_Email(data) {
    if (data.statusCode == 7) {
      this.openSnackBar("Email Not Sent.Please Check your email Configuration .", "OK");
    } else if (data.statusCode == 1) {
      this.openSnackBar("Email send Successfully.", "OK");
    }
  }
  failed_send_Email(err) {
    if (err.status == 403) {
      this.openSnackBar("You Don't have Permission", "OK");
    } else if (err.error.statusCode == 422) {
      this.openSnackBar(err.error.message, "OK");
    } else {
      this.openSnackBar("API Failed", "OK");
    }
  }

  success_update_patid_app_table(data) {

    this.openSnackBar("UHID - " + this.patientdetails.pkRegId + ", Registration Done From Fresh Appointment", "OK");
  }

  failed_update_patid_app_table(err) {
    this.showspinner = false;
    if (err.status == 403) {
      this.openSnackBar("You Don't have Permission", "OK");
    } else if (err.error.statusCode == 422) {
      this.openSnackBar(err.error.message, "OK");
    } else {
      this.openSnackBar("API Failed", "OK");
    }

  }

  failed_appt_save(err) {
    this.showspinner = false;
    if (err.status == 403) {
      this.openSnackBar("You Don't have Permission", "OK");
    } else if (err.error.statusCode == 422) {
      this.openSnackBar(err.error.message, "OK");
    } else {
      this.openSnackBar("API Failed", "OK");
    }

  }

  getpersonMasterSpecific(SearchType: string, PersonName: any) {
    return this.http.get<any>(this.dashboardService.newbaseUrl + "PersonMaster/" + SearchType + '/' + PersonName)
  }
  getpersonmaster(SearchType: string, PersonName: any) {
    this.http.get<any>(this.dashboardService.newbaseUrl + "PersonMaster/" + SearchType + '/' + PersonName).
      subscribe(data => this.success_personmaster(data), err => this.failed_personmaster(err));
  }
  success_personmaster(data) {
    // console.log(data);
    this.personmaster = data;
    this.refferedby_name = null;
    const personmaster_obj = this.personmaster.find(item => item.pkPersonId == this.patientdetails.fkReferredbyId);
    if (personmaster_obj?.personName != null) {
      this.refferedby_name = personmaster_obj?.personName;

    }
    else {
      this.refferedby_name = null;
    }
  }
  failed_personmaster(err) {
    if (err.status == 403) {
      this.openSnackBar("You Don't have Permission", "OK");
    } else if (err.error.statusCode == 422) {
      this.openSnackBar(err.error.message, "OK");
    } else {
      this.openSnackBar("API Failed", "OK");
    }
  }


  getpartymaster() {
    this.http.get<any>(this.dashboardService.newbaseUrl + "PartyMaster").
      subscribe(data => this.success_partymaster(data), err => this.failed_partymaster(err));
  }


  success_partymaster(data) {
    this.partymaster = data;
    // for emr header
    this.partymaster_name = null;

    const partyname_obj = this.partymaster.find(item => item.pkPartyId == this.patientdetails.fkPartyId);
    if (partyname_obj?.partyName != null) {
      this.partymaster_name = partyname_obj?.partyName;

    }
    else {
      this.partymaster_name = null;
    }
  }











  failed_partymaster(err) {
    if (err.status == 403) {
      this.openSnackBar("You Don't have Permission", "OK");
    } else if (err.error.statusCode == 422) {
      this.openSnackBar(err.error.message, "OK");
    } else {
      this.openSnackBar("API Failed", "OK");
    }
  }

  get_otherinformation_tab_dd(flag: any) {
    this.http.get<any>(this.dashboardService.newbaseUrl + "Common/GetPopUpHelp/" + flag).
      subscribe(data => this.success_dd(data, flag), err => this.failed_dd(err));
  }

  success_dd(data, flag: any) {

    switch (flag) {
      case 'MARITALSTATUS': {
        this.MaritalStatus = data.filter(item => item.isActive == true);
        console.log("MS " + this.MaritalStatus[0].popupDescription);
        break;
      }
      case 'DISABLITY': {
        this.GetDisability = data.filter(item => item.isActive == true);
        break;
      }
      case 'GROUP': {

        this.GroupList = data.filter(item => item.isActive == true);
        // console.log("GL " + JSON.stringify(this.GroupList))

        break;
      }
      case 'BLOODGROUP': {
        this.GetBloodgroup = data.filter(item => item.isActive == true);
        // for emr header 
        this.bloodgroup_name = null;

        const blood_grp_obj = this.GetBloodgroup.find(item => item.pkPopupId == this.patientdetails.fkBloodGroupId);

        console.log("blood grp " + blood_grp_obj?.popupDescription);
        this.bloodgroup_name = blood_grp_obj?.popupDescription;

        break;
      }
      case 'LANGUAGE': {
        this.GetLaungauge = data.filter(item => item.isActive == true);
        break;
      }
      case 'OCCUPATION': {
        this.GetOccupation = data.filter(item => item.isActive == true);
        break;
      }
      case 'RELIGION': {
        this.GetReligion = data.filter(item => item.isActive == true);
        break;
      }
      case 'SOURCE': {
        this.GetSource = data.filter(item => item.isActive == true);
        break;
      }
      case 'VIPREF': {
        this.GetVIP = data.filter(item => item.isActive == true);
        break;
      }
      case 'NATIONALITY': {
        this.GetNationality = data.filter(item => item.isActive == true);
        break;
      }
    }
    this.dialog.closeAll();
  }
  failed_dd(err) {
    this.dialog.closeAll();
  }

  getinitials() {
    this.http.get<any>(this.dashboardService.newbaseUrl + "InitialMaster").
      subscribe(data => this.success_initials(data), err => this.failed_initials(err));
  }

  success_initials(data) {

    this.initials = data;

  }
  failed_initials(err) {
    if (err.status == 403) {
      this.openSnackBar("You Don't have Permission", "OK");
    } else if (err.error.statusCode == 422) {
      this.openSnackBar(err.error.message, "OK");
    } else {
      this.openSnackBar("API Failed", "OK");
    }
  }

  getareas(cityid: number, option: number) {
    this.dashboardService.showspinner = true;

    this.http.get<any>(this.dashboardService.newbaseUrl + "AreaMaster/" + cityid).
      subscribe(data => this.success_area(data, option), err => this.failed_area(err));
  }
  //om
  getappareas(cityid: number, option: number) {
    this.dashboardService.showspinner = true;

    this.http.get<any>(this.dashboardService.newbaseUrl + "AreaMaster/" + cityid).
      subscribe(data => this.success_area(data, option), err => this.failed_area(err));
  }
  success_area(data, option: number) {
    this.dashboardService.showspinner = false;
    if (option == 1) {
      this.areas = data;

      // if (this.patientdetails.pkRegId > 0) {
      //   //  this.patientdetails.fkPareaId = -5 ;
      // }
    }
    else {
      this.areas2 = data;

    }

  }
  failed_area(err) {
    this.dashboardService.showspinner = false;
    if (err.status == 403) {
      this.openSnackBar("You Don't have Permission", "OK");
    } else if (err.error.statusCode == 422) {
      this.openSnackBar(err.error.message, "OK");
    } else {
      this.openSnackBar("API Failed", "OK");
    }
  }

  getcities(districtid: number, option: number) {
    this.dashboardService.showspinner = true;
    this.http.get<any>(this.dashboardService.newbaseUrl + "CityMaster/GetCityStateCountryByDistrictId/" + districtid).
      subscribe(data => this.success_cities(data, option), err => this.failed_cities(err));
  }
  //om
  getapptcities(districtid: number, option: number) {
    this.dashboardService.showspinner = true;
    this.http.get<any>(this.dashboardService.newbaseUrl + "CityMaster/GetCityStateCountryByDistrictId/" + districtid).
      subscribe(data => this.success_appt_cities(data, option), err => this.failed_cities(err));
  }
  success_cities(data, option: number) {
    // 
    // alert("In Cities"+data[0].pkCityId);
    this.apptdetail.fkCityId = data[0].pkCityId;
    //this.patientdetails.fkPcityId = data[0].pkCityId;
    //console.log(data);
    this.dashboardService.showspinner = false;
    if (option == 1) {
      this.cities = data;

      //for update patient
      if (this.patientdetails.pkRegId > 0 || this.config_cityid != null) {

        this.patientdetails.fkPcityId = this.dis_state_countryid_obj[0].cityId;

        // for update patient
        this.getareas(this.patientdetails.fkPcityId, 1);
      }
    }
    else {
      this.cities2 = data;

      //for update patient
      if (this.patientdetails.pkRegId > 0 || this.config_cityid != null && data.length > 0) {

        this.patientdetails.fkLcityId = this.dis_state_countryid_obj2[0].cityId;

        // for update patient
        this.getareas(this.patientdetails.fkLcityId, 2);
      }
    }

  }
  //om
  success_appt_cities(data, option: number) {
    this.dashboardService.showspinner = false;
    if (option == 1) {
      this.cities = data;
      // console.log(data);
      //alert("City ID "+data);
      //for update patient
      //if (this.apptdetail.fkRegId > 0) {

      // this.patientdetails.fkPcityId = this.dis_state_countryid_obj[0].cityId;
      //alert(data[0].pkCityId);
      this.apptdetail.fkCityId = data[0].pkCityId;

      // this.apptdetail.fkPCityId=data[0].pkCityId;
      // for update patient

      this.getappareas(this.apptdetail.fkCityId, 1);
      //}
    }
    else {
      this.cities2 = data;

      //for update patient
      if (this.patientdetails.pkRegId > 0 || this.apptdetail.fkCityId != null) {

        // this.patientdetails.fkPcityId = this.dis_state_countryid_obj[0].cityId;

        // for update patient
        this.getappareas(this.patientdetails.fkLcityId, 2);
      }
    }

  }
  failed_cities(err) {
    this.dashboardService.showspinner = false;
    if (err.status == 403) {
      this.openSnackBar("You Don't have Permission", "OK");
    } else if (err.error.statusCode == 422) {
      this.openSnackBar(err.error.message, "OK");
    } else {
      this.openSnackBar("API Failed", "OK");
    }
  }

  getdistricts(stateid: number, option: number) {
    this.dashboardService.showspinner = true;
    if (option == 1) {
      this.districts = [];
    } else {
      this.districts2 = [];
    }
    this.http.get<any>(this.dashboardService.newbaseUrl + "DistrictMaster/" + stateid).
      subscribe(data => this.success_districts(data, option), err => this.failed_districts(err));
  }
  //om
  getapptdistricts(stateid: number, option: number) {
    this.dashboardService.showspinner = true;
    this.http.get<any>(this.dashboardService.newbaseUrl + "DistrictMaster/" + stateid).
      subscribe(data => this.success_appt_districts(data, option), err => this.failed_districts(err));
  }
  success_districts(data, option: number) {

    this.dashboardService.showspinner = false;
    if (option == 1) {
      this.districts = data;
      this.apptdetail.fkCityId = 0;
      // for update patient
      // if (this.patientdetails.pkRegId > 0 || this.config_cityid != null) {
      this.districtid = this.dis_state_countryid_obj[0].districtId;
      const chkDistrictId = data.filter(item => item.pkDistrictId == this.districtid);
      if (chkDistrictId.length > 0) {
        this.cities = [];
        this.areas = [];
        this.districtid = chkDistrictId[0].pkDistrictId;
        this.getcities(this.districtid, 1);
      } else {
        this.cities = [];
        this.areas = [];
        this.districtid = data[0].pkDistrictId;
        this.getcities(this.districtid, 1);
      }

      // }
    }
    else if (option == 2 && data.length > 0) {
      this.districts2 = data;

      this.localdistrictid = this.dis_state_countryid_obj2[0].districtId;
      const chkDistrictId = data.filter(item => item.pkDistrictId == this.localdistrictid);
      if (chkDistrictId.length > 0) {
        this.cities2 = [];
        this.areas2 = [];
        this.localdistrictid = chkDistrictId[0].pkDistrictId;
        this.getcities(this.localdistrictid, 2);
      } else {
        this.cities2 = [];
        this.areas2 = [];
        this.localdistrictid = data[0].pkDistrictId;
        this.getcities(this.localdistrictid, 2);
      }
      // this.getcities(this.localdistrictid, 2);
      // this.cities=[];
      // this.areas=[];
    }
    else {
      this.districts2 = data;
      if (this.patientdetails.pkRegId > 0 && data.length > 0) {
        this.localdistrictid = this.dis_state_countryid_obj2[0].districtId;

        this.getcities(this.localdistrictid, 2);
      }
    }

  }
  //om
  success_appt_districts(data, option: number) {
    this.dashboardService.showspinner = false;
    if (option == 1) {
      this.districts = data;

      // for update patient
      //    if (this.apptdetail.fkRegId > 0) {
      this.districtid = this.dis_state_countryid_obj[0].districtId;
      //alert("District ID-"+this.districtid);
      this.getapptcities(this.districtid, 1);
      //    }
    }
    else {
      this.districts2 = data;

      // for update patient
      if (this.patientdetails.pkRegId > 0) {
        this.localdistrictid = this.dis_state_countryid_obj2[0].districtId;

        this.getcities(this.localdistrictid, 2);
      }
    }

  }
  failed_districts(err) {
    this.dashboardService.showspinner = false;
  }
  getCountryCode() {
    return this.http.get<any>(this.dashboardService.newbaseUrl + "CountryMaster");
  }
  getcountries() {
    this.http.get<any>(this.dashboardService.newbaseUrl + "CountryMaster").
      subscribe(data => this.success_countries(data), err => this.failed_countries(err));
  }
  success_countries(data) {
    this.countries = data.filter(item => item.isActive == true);
  }
  failed_countries(err) {
    if (err.status == 403) {
      this.openSnackBar("You Don't have Permission", "OK");
    } else if (err.error.statusCode == 422) {
      this.openSnackBar(err.error.message, "OK");
    } else {
      this.openSnackBar("API Failed", "OK");
    }
  }

  getstates(countryid: number, option: number) {
    this.dashboardService.showspinner = true;
    if (option == 1) {
      this.states = [];
      this.districts = [];
      this.cities = [];
      this.areas = [];
    } else {
      this.states2 = [];
      this.districts2 = [];
      this.cities2 = [];
      this.areas2 = [];
    }
    this.http.get<any>(this.dashboardService.newbaseUrl + "StateMaster/" + countryid).
      subscribe(data => this.success_states(data, option), err => this.failed_states(err));
  }

  //om
  getappstates(countryid: number, option: number) {
    this.dashboardService.showspinner = true;
    this.http.get<any>(this.dashboardService.newbaseUrl + "StateMaster/" + countryid).
      subscribe(data => this.success_appt_states(data, option), err => this.failed_states(err));
  }
  getstates_sameas(countryid: number) {

    return this.http.get<any>(this.dashboardService.newbaseUrl + "StateMaster/" + countryid)
  }

  getdistricts_sameas(stateid: number) {
    return this.http.get<any>(this.dashboardService.newbaseUrl + "DistrictMaster/" + stateid)
  }

  getcities_sameas(disid: number) {
    return this.http.get<any>(this.dashboardService.newbaseUrl + "CityMaster/GetCityStateCountryByDistrictId/" + disid)
  }

  getareas_sameas(cityid: number) {
    return this.http.get<any>(this.dashboardService.newbaseUrl + "AreaMaster/" + cityid)
  }


  success_states(data, option: number) {
    // 
    this.dashboardService.showspinner = false;
    // alert("Option-"+option);
    if (option == 1) {
      this.states = data;
      //alert("PT ID "+this.patientdetails.pkRegId );
      //for update patient
      this.stateid = this.dis_state_countryid_obj[0].stateId;
      const sateid = data.filter(item => item.pkStateId == this.stateid);
      if (sateid.length > 0) {
        this.stateid = sateid[0].pkStateId;
        this.getdistricts(this.stateid, 1);
      } else {
        this.stateid = data[0].pkStateId;
        this.getdistricts(this.stateid, 1);
      }
      // if (this.patientdetails.pkRegId > 0 || this.config_cityid != null || this.config_cityid ==undefined) {
      // }

    }
    else {
      this.states2 = data;

      //for update patient
      if (data.length > 0) {
        //console.log ("city id " + this.dis_state_countryid_obj[0].cityId )

        this.localstateid = this.dis_state_countryid_obj2[0].stateId;
        const sateid = data.filter(item => item.pkStateId == this.localstateid);
        if (sateid.length > 0) {
          this.localstateid = sateid[0].pkStateId;
          this.getdistricts(this.localstateid, 2);
        } else {
          this.localstateid = data[0].pkStateId;
          this.getdistricts(this.localstateid, 2);
        }
      }
    }

  }
  //om
  success_appt_states(data, option: number) {
    this.dashboardService.showspinner = false;
    //alert("state-option"+option);
    if (option == 1) {
      this.states = data;
      // console.log(data);
      //for update patient
      //if (this.apptdetail.fkRegId > 0) {
      //console.log ("city id " + this.dis_state_countryid_obj[0].cityId )
      this.stateid = this.dis_state_countryid_obj[0].stateId;
      //  alert("State Id-"+this.stateid);
      this.getapptdistricts(this.stateid, 1);
      //}

    }
    else {
      this.states2 = data;

      //for update patient
      if (this.patientdetails.pkRegId > 0) {
        //console.log ("city id " + this.dis_state_countryid_obj[0].cityId )
        this.localstateid = this.dis_state_countryid_obj2[0].stateId;
        this.getdistricts(this.localstateid, 2);
      }
    }

  }
  failed_states(err) {
    this.dashboardService.showspinner = false;
    if (err.status == 403) {
      this.openSnackBar("You Don't have Permission", "OK");
    } else if (err.error.statusCode == 422) {
      this.openSnackBar(err.error.message, "OK");
    } else {
      this.openSnackBar("API Failed", "OK");
    }
  }

  // onFocusGetPatient(event) {
  //   let inputVal = event.target.value
  //   if (inputVal != '') {
  //     this.getpatientdetails(this.patientdetails.pkRegId);
  //   }
  // }
  getpatientdetails(patientid: number, type?: number) {
    this.agehide = true;
    if (this.checkshort == false) {
      this.get_patient_docurl();
      this.open_loader_Dialog();
    }
    this.patientdetails.m_CountryCode = null;
    console.log("patid: " + patientid)
    //http://49.50.108.154:7575/api/PatientRegistration/GetPatient/patientId
    this.http.get<any>(this.dashboardService.newbaseUrl + "PatientRegistration/GetPatient/" + patientid).
      subscribe(data => this.successpatient_details(data, type), err => this.failedpatient_details(err));
  }

  getpatientdetailsforReciept(patientid: number) {
    console.log('patient id', patientid)
    return this.http.get<any>(this.dashboardService.newbaseUrl + "PatientRegistration/GetPatient/" + patientid);
  }
  //om
  getapptdetails(apptid: number) {
    //  this.open_loader_Dialog();
    //this.dashboardService.showspinner = true;
    //start loading
    //this.openDialog();
    this.checkpatient = null;

    console.log("ApptId: " + apptid)
    //http://49.50.108.154:7575/api/PatientRegistration/GetPatient/patientId
    this.http.get<any>(this.dashboardService.newbaseUrl + "OpdAppointment/GetApptById/" + apptid).
      subscribe(data => this.successappt_details(data), err => this.failedappt_details(err));

  }

  getappointmentbyId(appoimtnetmentid: any) {
    return this.http.get<any>(this.dashboardService.newbaseUrl + "OpdAppointment/GetApptById/" + appoimtnetmentid);
  }
  onApptDetails(event) {

    let inputVal = event.target.value
    if (inputVal != '') {
      this.getappdetails(this.apptdetail.fkRegId);
    }
  }

  getPatientConfig() {
    return this.http.get<any>(
      this.dashboardService.newbaseUrl +
      "Patientregistration/PatientConfig/" +
      this.authService.Loggeduser.branchid
    );
  }
  getappdetails(patientid: number) {
    //  this.open_loader_Dialog();
    //this.dashboardService.showspinner = true;
    //start loading
    //this.openDialog();

    console.log("patid: " + patientid);
    //this.apptdetail.fkRegId=patientid;
    this.appServiceLocal = patientid;
    this.apptdetail.fkRegId = patientid;

    //http://49.50.108.154:7575/api/PatientRegistration/GetPatient/patientId
    this.http.get<any>(this.dashboardService.newbaseUrl + "PatientRegistration/GetPatient/" + patientid).
      subscribe(data => this.successapp_details(data), err => this.failedapp_details(err));
  }
  addvisitorData(data: any) {
    return this.http.post<any>(this.dashboardService.newbaseUrl + "VisitMaster/InsertOPDVisit", data)
  }


  setopdobject_values() {
    // = this.patientdetails.userid.toString();
    // this.opdvisitmodel.fkBillCategoryId = this.patientdetails.categoryid.toString();
    this.opdvisitmodel.fkRegId = this.patientdetails.pkRegId.toString();
    this.opdvisitmodel.fkBranchId = this.authService.Loggeduser.branchid.toString();

    // if( this.patientdetails.appId == undefined){
    //   this.opdvisitmodel.appId = null;
    // }
    // else{
    //   this.opdvisitmodel.appId = this.patientdetails.appId;
    // }



  }



  openSnackBar(message: string, action: string) {
    this.dashboardService.snackBar.open(message, action, {
      duration: 3000,
    })
  }


  appointmentBlock(apptime: any) {
    return this.http.post<any>(this.dashboardService.newbaseUrl + "AppointmentBlock/BlockAll", apptime);
  }
  clearfields() {

    // this.addresschecked = false;

    this.apptdetail = {};
    this.apptdetail.initial = '';

    this.apptdetail.fkCityId = 0;
    this.apptdetail.fkConsultantId = 0;
    this.stateid = 0;
    this.districtid = 0;
    this.countryid = 0;
    this.apptdetail.fkOccupationId = 0;
    this.apptdetail.fkRefById = 0;
    this.apptdetail.fkServiceId = 0;
    this.apptdetail.fkTakenOnId = 0;
    this.apptdetail.isCancelled = null;
    this.apptdetail.isSap = null;
    this.apptdetail.lastName = null;
    this.apptdetail.firstName = null;
    this.apptdetail.fkRegId = null;
    this.apptdetail.pkAppointmentId = null;
    this.apptdetail.sex = null;
    this.apptdetail.address = null;
    this.apptdetail.ageDays = null;
    this.apptdetail.ageMonth = null;
    this.apptdetail.ageYear = null;
    //
    this.apptdetail.fkForBranchId = null;
    this.apptdetail.daySrNo = null;
    this.apptdetail.fkApptTypeId = null;
    this.apptdetail.dob = null;
    this.apptdetail.emailAddress = null;
    this.apptdetail.remarks = null;
    this.apptdetail.isConfirm = null;
    this.apptdetail.isCancelled = null;
    this.apptdetail.tokenNo = null;
    //this.states = [];
    //this.districts = [];
    //this.cities = [];
    //this.areas = [];
    this.apptdetail.apptTime = this.appservice.times;
  }

  successapp_details(data) {

    if (data.pkRegId > 0) {
      const holdrefbyID = this.apptdetail.fkRefById;
      this.apptdetail = {};
      if (data.isExpired != true) {
        this.checkpatient = data.pkRegId;
        this.oldPatDetails = Object.assign({}, data)
        this.apptdetail = data;
        var tdate = null;
        if (data.dob != null) {
          this.apptdetail.dob = this.datePipe.transform(data.dob, "yyyy-MM-dd");
        } else {
          tdate = new Date(data.regDate);
          this.apptdetail.ageYear = this.apptdetail.ageYear != null ? this.apptdetail.ageYear : 0;
          this.apptdetail.ageMonth = this.apptdetail.ageMonth != null ? this.apptdetail.ageMonth : 0;
          this.apptdetail.ageDays = this.apptdetail.ageDays != null ? this.apptdetail.ageDays : 0;
          tdate.setDate(tdate.getUTCDate() - this.apptdetail.ageDays);
          tdate.setMonth(tdate.getMonth() - this.apptdetail.ageMonth);
          tdate.setFullYear(tdate.getFullYear() - this.apptdetail.ageYear);
          this.apptdetail.dob = this.datePipe.transform(tdate, "yyyy-MM-dd");

        }

        this.apptdetail.fkRegId = this.appServiceLocal;
        this.apptdetail.fkRegId = data.pkRegId;
        this.apptdetail.address = data.paddress;
        this.apptdetail.apptTime = this.appservice.times;
        this.is_nameEdit = true;
        this.is_surNameEdit = true;

        this.apptdetail.fkConsultantId = this.DoctorId;
        if (data.dob.length > 0) {
          this.getage(data.dob);

        }

        this.apptdetail.mobileNo = data.mobileNo;
        this.apptdetail.isVip = data.isvip;
        if (this.initials.length > 0) {
          const datainitai = this.initials.filter(item => item.initialName == this.apptdetail.initial);
          this.apptdetail.initial = datainitai.length > 0 ? datainitai[0].initialName : null;
        }
        // alert(data.mobileNo);

        this.apptdetail.fkTakenOnId = 578;
        this.apptdetail.fkRefById = this.apptdetail.fkReferredbyId == null ? holdrefbyID : this.apptdetail.fkReferredbyId;
        this.get_appt_city_district_state_country(data.fkPcityId, 1);

        //alert(this.apptdetail.address);ge
      } else {
        this.openSnackBar("Patient is Expired", "OK");
        return false;
      }
    } else {
      this.openSnackBar("Patient is Not Registered", "OK");
    }
  }
  check_nationality(name) {
    if (name == "Indian") {
      this.selectedValue = 'Aadhaar Card No.';
    } else {
      this.selectedValue = 'Nationality ID';
    }
  }
  getages(selecteddate: string) {

    var oms = selecteddate.split("T");
    let container = oms[0].split("-");
    //let container = containerF.split("-");
    // alert("Date-"+oms[0]);  
    let selecteddate_converted = container[0] + "/" + container[1] + "/" + container[2];

    let currenttime = this.datePipe.transform(new Date(), "hh:mm:ss");
    //  let dateofbirth = this.datePipe.transform(selecteddate, "yyyy-MM-dd");

    let dateofbirth = this.datePipe.transform(selecteddate_converted, "yyyy-MM-dd");

    let currentdate = this.datePipe.transform(new Date, "yyyy-MM-dd");
    let container2 = currentdate.split("-");
    // this.getDataDiffNew(new Date(dateofbirth), new Date(currentdate),container[2],container2[2]);
    this.getDataDiffs(new Date(dateofbirth), new Date(currentdate));

    //console.log("difference" + diff);
  }
  getDataDiffs(start, end) {

    let years: number = 0, months: number = 0, days: number;
    // Day diffence. Trick is to use setDate(0) to get the amount of days
    // from the previous month if the end day less than the start day.
    if (end.getDate() < start.getDate()) {
      months = -1;
      let datePtr: Date = new Date(end);
      datePtr.setDate(0);
      days = end.getDate() + (datePtr.getDate() - start.getDate());
    } else {
      days = end.getDate() - start.getDate();
    }

    if (end.getMonth() < start.getMonth() || (end.getMonth() === start.getMonth() && end.getDate() < start.getDate())) {
      years = -1;
      months += end.getMonth() + (12 - start.getMonth());
    } else {
      months += end.getMonth() - start.getMonth();
    }

    years += end.getFullYear() - start.getFullYear();

    this.patientdetails.ageYear = Math.abs(years);
    this.patientdetails.ageMonth = Math.abs(months);
    this.patientdetails.ageDays = Math.abs(days);


  }
  getDataDiffsAppt(start, end) {

    let years: number = 0, months: number = 0, days: number;
    // Day diffence. Trick is to use setDate(0) to get the amount of days
    // from the previous month if the end day less than the start day.
    if (end.getDate() < start.getDate()) {
      months = -1;
      let datePtr: Date = new Date(end);
      datePtr.setDate(0);
      days = end.getDate() + (datePtr.getDate() - start.getDate());
    } else {
      days = end.getDate() - start.getDate();
    }

    if (end.getMonth() < start.getMonth() || (end.getMonth() === start.getMonth() && end.getDate() < start.getDate())) {
      years = -1;
      months += end.getMonth() + (12 - start.getMonth());
    } else {
      months += end.getMonth() - start.getMonth();
    }

    years += end.getFullYear() - start.getFullYear();

    this.apptdetail.ageYear = Math.abs(years);
    this.apptdetail.ageMonth = Math.abs(months);
    this.apptdetail.ageDays = Math.abs(days);


  }
  successpatient_details(data, type?: number) {
    if (data.pkRegId > 0) {
      this.activevisit = 1;
      this.enableBarSticker = true;
      if (data.fkReferredbyIdLatest > 0) {
        data.fkReferredbyId = data.fkReferredbyIdLatest;
      }
      this.ipdId = data.fkIPDID;
      this.patientdetails = data;
      var tdate = null;
      if (type == 0) {
        if (data.dob != null) {
          this.patientdetails.dob = this.datePipe.transform(data.dob, "yyyy-MM-dd");
        } else {
          tdate = new Date(data.regDate);
          this.patientdetails.ageYear = this.patientdetails.ageYear != null ? this.patientdetails.ageYear : 0;
          this.patientdetails.ageMonth = this.patientdetails.ageMonth != null ? this.patientdetails.ageMonth : 0;
          this.patientdetails.ageDays = this.patientdetails.ageDays != null ? this.patientdetails.ageDays : 0;
          tdate.setDate(tdate.getUTCDate() - this.patientdetails.ageDays);
          tdate.setMonth(tdate.getMonth() - this.patientdetails.ageMonth);
          tdate.setFullYear(tdate.getFullYear() - this.patientdetails.ageYear);
          this.patientdetails.dob = this.datePipe.transform(tdate, "yyyy-MM-dd");

        }
      } else {
        if (data.dob != null) {
          this.patientdetails.dob = this.datePipe.transform(data.dob, "yyyy-MM-dd");
          this.getages(data.dob);
        } else {
          tdate = new Date(data.regDate);
          this.patientdetails.ageYear = this.patientdetails.ageYear != null ? this.patientdetails.ageYear : 0;
          this.patientdetails.ageMonth = this.patientdetails.ageMonth != null ? this.patientdetails.ageMonth : 0;
          this.patientdetails.ageDays = this.patientdetails.ageDays != null ? this.patientdetails.ageDays : 0;
          tdate.setDate(tdate.getUTCDate() - this.patientdetails.ageDays);
          tdate.setMonth(tdate.getMonth() - this.patientdetails.ageMonth);
          tdate.setFullYear(tdate.getFullYear() - this.patientdetails.ageYear);
          this.patientdetails.dob = this.datePipe.transform(tdate, "yyyy-MM-dd");
          this.getDataDiffs(new Date(this.patientdetails.dob), new Date(this.datePipe.transform(this.authService.localDate, "yyyy-MM-dd")));
        }

      }
      if (this.initials.length > 0) {
        const datainitai = this.initials.filter(item => item.initialName == this.patientdetails.initial);
        this.patientdetails.initial = datainitai.length > 0 ? datainitai[0].initialName : null;
      }

      this.patInfoDetails = this.patientdetails;
      let nationality = this.GetNationality.filter(item => item.pkPopupId == data.fkNationalityId);
      let viptype = this.GetVIP.filter(item => item.pkPopupId == data.fkViprefId);
      let meritalStatus = this.MaritalStatus.filter(item => item.pkPopupId == data.fkMaritalId);
      let partyNameObj = this.partymaster.filter(item => item.pkPartyId == data.fkPartyId);
      // let refname = this.personmaster.filter(item => item.pkPersonId == data.fkReferredbyId);
      let GrpName = this.GroupList.filter(item => item.pkPopupId == data.fkGroupId);
      let occName = this.GetOccupation.filter(item => item.pkPopupId == data.fkOccupationId);
      if (occName.length > 0) {
        this.ShowOccupationName = occName[0].popupDescription;
      } else {
        this.ShowOccupationName = null;
      }

      if (GrpName.length > 0) {
        this.ShowGroupName = GrpName[0].popupDescription;
      } else {
        this.ShowGroupName = null;
      }

      // if (refname.length > 0) {
      //   this.ShowReferdByName = refname[0].personName;
      // } else {
      //   this.ShowReferdByName = null;
      // }

      if (partyNameObj.length !== 0) {
        this.partymaster_name = partyNameObj[0].partyName;
      }
      else {
        this.partymaster_name = null;
      }
      if (nationality.length !== 0) {
        this.patientdetails.nationality = nationality[0].popupDescription;
        this.nationalityname = nationality[0].popupDescription;
        this.check_nationality(this.nationalityname);
      } else {
        this.nationalityname = null;
        this.patientdetails.nationality = "";
      }
      if (viptype.length !== 0) {
        this.patientdetails.viptype = viptype[0].popupDescription;
      } else {
        this.patientdetails.viptype = "";
      }
      if (meritalStatus.length !== 0) {
        this.patientdetails.meritalStatus = meritalStatus[0].popupDescription;
      } else {
        this.patientdetails.meritalStatus = "";
      }
      this.registereddate = data.regDate?data.regDate:this.datePipe.transform(this.authService.localDate, "yyyy-MM-dd");
      this.registeredtime =  data.regTime?data.regTime.slice(0, 5):new Date().toTimeString().split(" ")[0];
      this.checkpatient = data.pkRegId;
      this.reffertypeid = this.patientdetails.fkReferredbyId;
      if (this.apptdetail.fkRefById != undefined && this.apptdetail.fkRefById != null) {
        this.patientdetails.fkReferredbyId = this.apptdetail.fkRefById;
      }
      if (this.patientdetails.dob == null) {
        this.getdob(1);
        this.getdob(2);
        this.getdob(3);
      } else {
        this.patientdetails.dob = this.datePipe.transform(data.dob, "yyyy-MM-dd");
      }

      this.patientdetails.localpinCode = data.localPinCode;
      this.PatientisExpire = data.isExpired;
      this.PatientpartyId = data.fkPartyId
      //console.log ("pat vip status " + this.patientdetails.isvip);
      if (this.patientdetails.firstName == undefined) {
        this.patientn = this.patientdetails.firstName;
      } else {
        this.patientn = this.patientdetails.firstName + ' ' + this.patientdetails.lastName;
      }
      if (this.callsepecificApi == 'BILLING') {
        this.billingservice.GetIpdRegListByRegId(data.pkRegId).subscribe(data => {
          if (data.length > 0) {
            this.ipdRegistrationDetail = data.filter(item => item.fk_BillId == 0);

          }
        });
      } else if (this.callsepecificApi == 'ALL') {
        //get last visit
        this.getpatient_lastvisit();
        //get dist, state and country based on city id permanent
        if (this.patientdetails.fkPcityId != null) {
          this.get_city_district_state_country(this.patientdetails.fkPcityId, 1);
        }

        //get dist, state and country based on city id local
        if (this.patientdetails.fkLcityId != null) {
          this.get_city_district_state_country(this.patientdetails.fkLcityId, 2);
        }
      }
      if (data.m_CountryCode == null) {
        this.patientdetails.m_CountryCode = '+91';
      }
      if (this.checkshort == false) {
        this.dialog.closeAll();
        //get patient docs 
        this.get_patient_docs();
        this.get_old_photo();
        if (this.callsepecificApi == 'OPDVISIT') {
          this.callForkjoin(data.pkRegId)
        }

      }



      // console.log("patient details successfull");
      //console.log(data);
    } else {
      if (this.checkshort == false) {
        this.dialog.closeAll();
      }
      this.openSnackBar("This Patient is not Registered", "ok");
    }
  }
  getpatient_lastvisit() {
    this.BillingDoctorId = ' ';
    this.http.get<any>(this.dashboardService.newbaseUrl + "VisitMaster/GetLastVisit/"
      + this.patientdetails.pkRegId + '/' + this.authService.Loggeduser.specialityId).subscribe(
        data => this.success_lastvisit(data), err => this.failed_lastvisit(err)
      )
  }

  getlastvisit(id: number) {
    return this.http.get<any>(this.dashboardService.newbaseUrl + "VisitMaster/GetLastVisit/"
      + id + '/' + this.authService.Loggeduser.specialityId)
  }

  success_lastvisit(data) {
    if (data.isEmergency != null) {
      this.opdvisitmodel.isEmergency = data.isEmergency;
    }
    this.getlastvisitid = data.fk_VisitId ? data.fk_VisitId : 0;
    if (data.fK_DoctorId != null) {
      this.opdvisitmodel.fkDoctorId = data.fK_DoctorId;
    }
    if (data.fK_CategoryId != null) {
      this.opdvisitmodel.fkBillCategoryId = data.fK_CategoryId;
    }
    this.BillingDoctorId = data.fK_DoctorId;
  }
  failed_lastvisit(err) {
    //this.opdvisitmodel.fkDoctorId = null;
    //  this.openSnackBar("last visit api failed", "OK");
  }

  getage(selecteddate: string) {

    var oms = selecteddate.split("T");
    let container = oms[0].split("-");
    //let container = containerF.split("-");
    // alert("Date-"+oms[0]);  
    let selecteddate_converted = container[0] + "/" + container[1] + "/" + container[2];

    let currenttime = this.datePipe.transform(new Date(), "hh:mm:ss");
    //  let dateofbirth = this.datePipe.transform(selecteddate, "yyyy-MM-dd");

    let dateofbirth = this.datePipe.transform(selecteddate_converted, "yyyy-MM-dd");

    let currentdate = this.datePipe.transform(new Date, "yyyy-MM-dd");
    let container2 = currentdate.split("-");
    // this.getDataDiffNew(new Date(dateofbirth), new Date(currentdate),container[2],container2[2]);
    this.getDataDiff(new Date(dateofbirth), new Date(currentdate));

    //console.log("difference" + diff);
  }

  getdob(type: any) {
    switch (type) {

      case 1: {
        var tdate = new Date();
        if (this.patientdetails.ageYear == null || this.patientdetails.ageYear == undefined) {
          this.patientdetails.ageYear = 0;
        }
        this.patientdetails.ageMonth = 0;
        this.patientdetails.ageDays = 0;
        tdate.setFullYear(tdate.getFullYear() - this.patientdetails.ageYear);
        tdate.setMonth(tdate.getMonth() - this.patientdetails.ageMonth);
        tdate.setDate(tdate.getUTCDate() - this.patientdetails.ageDays);
        this.patientdetails.dob = this.datePipe.transform(tdate, "yyyy-MM-dd");
        break;
      }
      case 2: {
        var tdate = new Date();
        if (this.patientdetails.ageMonth > 11 || this.patientdetails.ageMonth <= 0) {
          //  this.openSnackBar("Please enter months in between 0 to 12", "OK");
          this.patientdetails.ageMonth = 0;
          return false;
        }
        if (this.patientdetails.ageYear == undefined || this.patientdetails.ageYear == null) {
          this.patientdetails.ageYear = 0;
        }
        this.patientdetails.ageDays = 0;
        tdate.setDate(tdate.getUTCDate() - this.patientdetails.ageDays);
        tdate.setMonth(tdate.getMonth() - this.patientdetails.ageMonth);
        tdate.setFullYear(tdate.getFullYear() - this.patientdetails.ageYear);
        this.patientdetails.dob = this.datePipe.transform(tdate, "yyyy-MM-dd");
        break;
      }
      case 3: {
        var tdate = new Date();
        if (this.patientdetails.ageDays > 31 || this.patientdetails.ageDays <= 0) {
          //  this.openSnackBar("Please enter days in between 0 to 31", "OK");
          this.patientdetails.ageDays = 0;
          return false;
        }
        if ((this.patientdetails.ageMonth == undefined || this.patientdetails.ageMonth == null) && (this.patientdetails.ageYear == undefined || this.patientdetails.ageYear == null)) {
          this.patientdetails.ageMonth = 0;
          this.patientdetails.ageYear = 0;
        }
        tdate.setDate(tdate.getUTCDate() - this.patientdetails.ageDays);
        tdate.setMonth(tdate.getMonth() - this.patientdetails.ageMonth);
        tdate.setFullYear(tdate.getFullYear() - this.patientdetails.ageYear);
        this.patientdetails.dob = this.datePipe.transform(tdate, "yyyy-MM-dd");
      }
    }



    // console.log("new date " + this.apptdetail.dob);

  }
  // getdob(typedValue: number){

  //   const tdate = new Date();
  //   const dobyear = tdate.getFullYear() - typedValue;
  // let datestring = tdate.getUTCDate() + "/" + tdate.getMonth() + "/" + dobyear;
  // let container = datestring.split("/", 3);

  // let selecteddate_converted = container[1] + "/" + container[0] + "/" + container[2];


  // }
  getDataDiffNew(dob, current, nowDay, dobDay) {

    //   alert("Current-"+current+" dob-"+dob);
    //   let years: number = 0, months: number = 0, days: number;
    //   days = (current.getTime() - dob.getTime())/(1000 * 3600 * 24); 
    //   alert("days-"+days/365);

    var ageyear = current.getFullYear() - dob.getFullYear();
    var agemonth = current.getMonth() - dob.getMonth();
    var ageday = current.getDate() - dob.getDate();

    if (agemonth <= 0) {
      ageyear--;
      agemonth = (12 + agemonth);
    }
    if (nowDay < dobDay) {
      agemonth--;
      ageday = 30 + ageday;
    }
    else {
      ageday = nowDay - dobDay;

    }
    if (agemonth == 12) {
      ageyear = ageyear + 1;
      agemonth = 0;
    }
    this.apptdetail.ageYear = ageyear;
    this.apptdetail.ageMonth = agemonth;
    this.apptdetail.ageDays = ageday;

    //alert("Age in Year:" + ageyear + ',' + 'Month:' + agemonth + ',' + 'Day:' + ageday);
  }

  getDataDiff(start, end) {


    let years: number = 0, months: number = 0, days: number;
    // Day diffence. Trick is to use setDate(0) to get the amount of days
    // from the previous month if the end day less than the start day.
    if (end.getDate() < start.getDate()) {
      months = -1;
      let datePtr: Date = new Date(end);
      datePtr.setDate(0);
      days = end.getDate() + (datePtr.getDate() - start.getDate());
    } else {
      days = end.getDate() - start.getDate();
    }

    if (end.getMonth() < start.getMonth() || (end.getMonth() === start.getMonth() && end.getDate() < start.getDate())) {
      years = -1;
      months += end.getMonth() + (12 - start.getMonth());
    } else {
      months += end.getMonth() - start.getMonth();
    }

    years += end.getFullYear() - start.getFullYear();

    this.apptdetail.ageYear = years;
    this.apptdetail.ageMonth = months;
    this.apptdetail.ageDays = days;


  }


  successappt_details(data) {

    this.checkpatient = null;
    this.apptdetail = data;
    this.patientn = data.firstName + ' ' + data.lastName;
    this.patientdetails.fkReferredbyId = this.apptdetail.fkRefById;
    this.patientdetails.mobileNo = data.contactNo;
    this.apptdetail.mobileNo = data.contactNo;
    this.apptdetail.fkCityId = data.fkCityId;
    let partyNameObj = this.partymaster.filter(item => item.pkPartyId == data.fK_PartyId);
    if (partyNameObj.length !== 0) {
      this.partymaster_name = partyNameObj[0].partyName;
    }
    else {
      this.partymaster_name = null;
    }
    this.opdvisitmodel.remarks = data.remarks;
    // console.log('refe', this.patientdetails.fkReferredbyId)
    this.checkpatient = this.apptdetail.fkRegId;

    //  this.patientdetails.pkRegId = this.apptdetail.fkRegId;
    if (data.dob.length > 0) {
      this.getDataDiffsAppt(new Date(data.dob), new Date(this.authService.localDate));
    }



    //added by sachin for opd visit
    this.fill_opdvisit_form();
    // sachin code ended
    // this.getpersonmaster();
    if (this.callsepecificApi == 'OPDVISIT') {
      this.callForkjoin(data.pkRegId)
    } else {
      this.get_appt_city_district_state_country(this.apptdetail.fkCityId, 1);
    }
  }

  fill_opdvisit_form() {
    console.log('appt', this.apptdetail)
    this.checkpatient = this.apptdetail.fkRegId;
    // fkRegId
    //set app id so we can check it at the time saving opd vist to get confirm opd visit is created directly or from appointment
    this.opdvisitmodel.appId = this.apptdetail.pkAppointmentId;
    // this.patientdetails.fkReferredbyId =  this.apptdetail.fkRefById;
    // this.pkPersonId = this.apptdetail.fkRefById;
    //;

    //we need some fields like age, sex and name on opd visit form so we need to set this 
    this.setpatientfields();

    if (this.apptdetail.fkRegId > 0 || this.apptdetail.fkRegId == null && this.pendingAppointment == false) {


      //do nothing

      //this.patientdetails.fkReferredbyId = this.apptdetail.fkRefById;

    }
    else {

      // save patient as it is first time appointment and patient is not created yet
      this.flag_reg_from_appointments = true;
      this.pendingAppointment = false;
      this.patientdetails.fk_AppointmentID = this.opdvisitmodel.appId;
      this.savepatientdetails();
    }

  }

  setpatientfields() {
    // sex":"M","address":"sfsdfs","emailAddress":null,"fkCityId":976,"contactNo":"3333333333",
    // "fkRefById":1,"fkConsultantId":3,"isVip":null,"fkTakenOnId":578,"remarks":"fsfsfsdfsd",
    // "isConfirm":true,"isCancelled":false,"fkCreatedById":1,"isReScheduled":null,"rescheduleDate":null,
    // "isSentSms":null,"isSentSmsreScheduled":null,"isActive":true,"pkSynchId":null,
    // "isSentSmsreminder":null,"fkServiceId":11,"isSap":null,"fkModifiedById":null,"fkOccupationId":0,
    // "tokenNo":"1","fkApptType":null,"fkBranch":null,"fkCity":null,"fkConsultant":null,
    // "fkForBranch":null,"fkRefBy":null,"fkReg":null,"fkTakenOn":null

    //set doctor to show on opdvisit form
    this.opdvisitmodel.fkDoctorId = this.apptdetail.fkConsultantId;

    this.patientdetails.initial = this.apptdetail.initial;

    this.patientdetails.pkRegId = this.apptdetail.fkRegId;
    this.patientdetails.firstName = this.apptdetail.firstName;
    this.patientdetails.lastName = this.apptdetail.lastName;
    this.patientdetails.ageYear = this.apptdetail.ageYear;
    this.patientdetails.ageDays = this.apptdetail.ageDays;
    this.patientdetails.ageMonth = this.apptdetail.ageMonth;
    this.patientdetails.dob = this.apptdetail.dob;
    this.patientdetails.sex = this.apptdetail.sex;
    this.patientdetails.paddress = this.apptdetail.address;
    this.patientdetails.emailAddress = this.apptdetail.emailAddress;
    this.patientdetails.fkPcityId = this.apptdetail.fkCityId;
    this.patientdetails.fkPartyId = this.apptdetail.fK_PartyId;
    if (this.apptdetail.isVip != null) {
      this.patientdetails.isvip = (this.apptdetail.isVip).toString();
    }
    //  if (this.apptdetail.isSap != null) { 
    this.patientdetails.isSap = this.apptdetail.isSap;
    // }
    // 
    // this.patientdetails.mobileNo = this.apptdetail.contactNo;


  }

  convertTo24Hour(time) {
    var hours = parseInt(time.substr(0, 2));
    if (time.indexOf('AM') != -1 && hours == 12) {
      time = time.replace('12', '0');
    }
    if (time.indexOf('PM') != -1 && hours < 12) {
      time = time.replace(hours, (hours + 12));
    }
    return time.replace(/(AM|PM)/, '');
  }

  failedapp_details(err) {
    this.dialog.closeAll();
    if (err.status == 403) {
      this.openSnackBar("You Don't have Permission", "OK");
    } else if (err.error.statusCode == 422) {
      this.openSnackBar(err.error.message, "OK");
    } else {
      this.openSnackBar("No patient found", "Ok");
    }
  }
  failedpatient_details(err) {
    this.dialog.closeAll();
    // this.dashboardService.showspinner = false;
    if (err.status == 403) {
      this.openSnackBar("You Don't have Permission", "OK");
    } else if (err.error.statusCode == 422) {
      this.openSnackBar(err.error.message, "OK");
    } else {
      this.openSnackBar("No patient found", "Ok");
    }
    this.patientdetails = {};
  }
  //om
  failedappt_details(err) {
    this.dialog.closeAll();
    this.patientdetails = {};
    if (err.status == 403) {
      this.openSnackBar("You Don't have Permission", "OK");
    } else if (err.error.statusCode == 422) {
      this.openSnackBar(err.error.message, "OK");
    } else {
      this.openSnackBar("API Failed", "OK");
    }
  }
  formatdate(date: string) {

    if (date == null) {
      return "";
    }
    else {
      var splitted = date.split("T", 2);
      return splitted[0];
    }

  }

  // openDialog(): void {

  //   const dialogRef = this.dialog.open(LoaderComponent, {
  //     width: '150px',
  //     data: {

  //     }
  //   });

  //   dialogRef.afterClosed().subscribe(result => {

  //     //pid = result;
  //   });
  // }
  getPateintTempDetails(tempid, appointmentid, MobileNo, Name, searchType) {
    return this.http.get<any>(this.dashboardService.newbaseUrl + "PatientRegistration/GetTempPatientDataByTranIdByAppointmentIDByMobileNoByPatientNameBySerachType/" + tempid + '/' + appointmentid + '/' + MobileNo + '/' + Name + '/' + searchType);
  }
  createRandomString(length: any, type: any) {
    var chars = ''
    if (type == 'S') {
      chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    } else if (type == 'N') {
      chars = "0123456789";
    }
    let result = "";
    for (let i = 0; i < length; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
  }
  transformchar(value: string) {

    var checkcases = this.documentrul.filter(item => item?.propertyName == "PatientNameCaseType");
    if (checkcases.length > 0 && checkcases[0]?.propertyValue.toLowerCase() == 'upper' && checkcases[0]?.propertyValue != null) {
      if (!value) return value; // safeguard
      return value.toUpperCase().replace(/\b\w/g, s => s.toUpperCase());
    }
    else if (checkcases.length > 0 && checkcases[0]?.propertyValue.toLowerCase() == 'lower' && checkcases[0]?.propertyValue != null) {
      if (!value) return value; // safeguard
      return value.toLowerCase().replace(/\b\w/g, s => s.toLowerCase());
    } else {
      if (!value) return value; // safeguard
      let words: RegExp = /\b(?!of|by|the)\w+/g;
      let newVal = value.replace(words, (match) => {
        return match.replace(/^\w/, (word) => word.charAt(0).toUpperCase() + word.substr(1).toLowerCase());
      })
      return newVal.charAt(0).toUpperCase() + newVal.substr(1);
    }
  }
}

